const getPortfolioImages = (slug, maxCount = 20) => {
  const images = [];
  for (let i = 1; i <= maxCount; i++) {
    const imgPath = `/assets/images/house/${slug}/${i}.jpg`;
    images.push({ image: imgPath });
  }
  return images;
};

const HouseDetailPageInfo = [
  {
    slug: "villa-jasmine",
    itype: "house",
    imageCount: 18,
    title: "Villa Jasmin",
    secondTitle: "£ 3,000,000",
    description: "GOCEK, FETHIYE",
    detailTitle: "Göcek Bay Grand Villa",
    detailDescription:
      "A superb and spacious villa overlooking the world famous Göcek bay area.",
    mainImage: "/assets/images/house/villa-jasmine/10.jpg",
    beds: 5,
    baths: 5,
    area: "1000 m2",
    content: [
      {
        type: "paragraph",
        text: "Göcek Bay Grand Villa – A Private Refuge Between the Mountains and the Sea Rising gracefully above the emerald slopes of Göcek, this exceptional villa captures the essence of Mediterranean refinement — where light, silence, and space converge. With its uninterrupted, breathtaking views over Göcek Bay and the surrounding pine-clad mountains, the residence embodies a sense of freedom and exclusivity that few properties in the region can match. Every sunrise glimmers across the water, and every evening closes with the golden reflection of the setting sun over the yachts below.",
      },
      {
        type: "paragraph",
        text: "An Architectural Statement Set across three levels, the villa has been designed to dissolve the boundaries between indoors and outdoors. Its architecture draws inspiration from the region’s coastal heritage, blending natural stone, wood, and glass to create a structure both timeless and modern. Expansive terraces wrap around the living spaces, providing sweeping perspectives of the bay and allowing the sea breeze to move effortlessly through the house. Inside, high ceilings, generous proportions, and meticulous craftsmanship lend the home an atmosphere of serene grandeur.",
      },
      {
        type: "paragraph",
        text: "The open-plan living area extends onto the pool terrace, merging seamlessly with the panoramic landscape. Whether hosting a candlelit dinner under the stars or enjoying a quiet morning coffee, the villa’s design ensures every moment unfolds against a stunning natural backdrop.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-jasmine/2.jpg",
        alt: "Serenity Villa Exterior",
      },
      {
        type: "paragraph",
        text: "Wellness and Leisure at Home This villa has been thoughtfully conceived as a sanctuary for both body and mind. A private Turkish bath (hamam) and sauna bring the essence of Anatolian spa culture into your daily life — intimate, elegant, and restorative. After a swim in the pool or a day spent exploring Göcek’s hidden coves, these spaces invite complete relaxation, enveloped in marble and soft light. A private enclosed garage adds convenience and security, with direct access to the interior of the home.",
      },
      {
        type: "blockquote",
        text: "Private Garden & Outdoor Living The villa sits on a spacious, beautifully landscaped plot, where Mediterranean flora thrives in harmony with the architecture. Mature olive and citrus trees, stone pathways, and vibrant bougainvillea create a natural rhythm around the property. The large swimming pool forms the centerpiece of the garden, surrounded by sun decks, shaded pergolas, and quiet seating corners — each designed to capture a different view of the bay. The garden is more than a setting; it is a living extension of the home, where nature becomes part of daily life.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-jasmine/4.jpg",
        alt: "Villa Interior",
      },
      {
        type: "paragraph",
        text: "Elegance in Every Detail Each bedroom is conceived as a private suite, complete with an en-suite bathroom, generous wardrobe space, and access to balconies or terraces. The master suite commands an extraordinary vantage point, overlooking the glittering Göcek Bay and the distant islands. Inside, the palette of neutral tones, soft textures, and carefully selected materials reflects the villa’s refined spirit — discreet luxury with a deep connection to its environment.",
      },
      {
        type: "paragraph",
        text: "The Göcek Lifestyle Göcek remains one of the Mediterranean’s most coveted destinations, celebrated for its world-class marinas, fine dining, and quiet elegance. This villa is perfectly positioned to enjoy the town’s amenities while maintaining absolute privacy — a short drive from the harbor, yet high enough to feel completely secluded. Here, days unfold at an unhurried rhythm: a morning swim, a stroll through olive groves, a sunset dinner overlooking the bay.",
      },
      {
        type: "list",
        items: [
          "Plot: Expansive private garden",
          "Floors: 3",
          "Bedrooms: 5",
          "Bathrooms: 5",
          "Wellness: Private Turkish bath & sauna",
          "Views: Panoramic and unobstructed Göcek Bay and mountain views",
          "Pool: Large private pool with wooden deck",
          "Pool: Large private pool with wooden deck",
          "Outdoor Spaces: Multiple terraces, pergolas, and lounge areas",
          "Architecture: Elegant Mediterranean design emphasizing natural light and open flow",
        ],
      },
    ],

    PortfolioList2: getPortfolioImages("villa-jasmine"),
  },
  {
    slug: "serenity-house",
    itype: "house",
    imageCount: 30,
    title: "Serenity House",
    secondTitle: "£ 3,000,000",
    description: "OVACIK, FETHIYE",
    detailTitle: "Luxury Estate",
    detailDescription:
      "A Prestigious Estate with Guest House on a 1,955 m² Plot in Fethiye",
    beds: 5,
    baths: 5,
    area: "2000 m2",
    content: [
      {
        type: "paragraph",
        text: "Set within one of Fethiye’s most desirable neighbourhoods, this elegant stone-built estate combines timeless Mediterranean charm with modern comfort. Occupying a private 1,955 m² plot framed by mature gardens and panoramic views of the world-famous Babadağ Mountain, the property offers exceptional privacy and space.",
      },
      {
        type: "paragraph",
        text: "The main two-storey villa features five spacious bedrooms, light-filled living areas, and expansive terraces designed for outdoor living. An arched garden lounge provides a peaceful retreat for warm summer evenings, while the upper floor enjoys sunlight throughout the day.",
      },
      {
        type: "image",
        src: "/assets/images/house/serenity-house/19.jpg",
        alt: "Serenity Villa Exterior",
      },
      {
        type: "paragraph",
        text: "A separate stone-built guest house offers flexible use as guest accommodation, an artist’s studio, or a private office. The grounds include a private parking area, a barbecue zone, and a fully operational undercover outdoor kitchen and dining area — perfect for entertaining in any season. Beautifully landscaped gardens, enclosed by traditional stone walls, complete the setting.",
      },
      {
        type: "blockquote",
        text: "Every window frames a view — Mount Babadağ, the cable car line, and paragliders gliding across the sky. Every space captures the golden light and calm rhythm of nature.",
      },
      {
        type: "image",
        src: "/assets/images/house/serenity-house/17.jpg",
        alt: "Villa Interior",
      },
      {
        type: "paragraph",
        text: "The Garden That Shapes the Soul of the Villa. The true spirit of this property lies in its garden — a living canvas of olive trees, pines, and lavender...",
      },
    ],
    videoPic: "/assets/images/house/serenity-house/13.jpg",
    videoId: "EHYwtTDPOTc",
    videoText:
      "This property is more than a home — it’s a lifestyle shaped by nature.",
    PortfolioList2: getPortfolioImages("serenity-house"),
  },
  {
    slug: "faralya-estate",
    itype: "house",
    imageCount: 29,
    title: "Faralya Estate",
    secondTitle: "£ 2,630,000",
    description: "FARALYA, FETHİYE",
    detailTitle: "Magnificent 3,000 m² Tiered Estate",
    detailDescription:
      "Former Boutique Hotel • Panoramic Sea Views • Ideal for Yoga Retreats & Wellness Resorts**",
    mainImage: "/assets/images/house/faralya-estate/15.jpg",
    beds: "10 +",
    baths: "10 +",
    area: "3000 m2",
    content: [
      {
        type: "paragraph",
        text: "Set across a beautifully designed 3,000 m² tiered plot overlooking the shimmering Mediterranean, this extraordinary estate in Faralya stands as one of the region’s most versatile and unique properties. Combining traditional stone-built architecture with expansive modern living spaces, the estate offers multiple layers of accommodation, tranquil garden terraces, and breathtaking sea views from almost every vantage point.",
      },
      {
        type: "paragraph",
        text: "Originally operating as a boutique hotel, the property now presents a rare opportunity for investors, retreat organisers, or families seeking a large private residence in a serene and prestigious coastal setting. The estate’s impressive scale, natural surroundings, and existing hospitality infrastructure make it ready for immediate use, with ample room for expansion or redevelopment depending on the buyer’s vision.",
      },
      {
        type: "paragraph",
        text: "This exceptional estate offers expansive accommodation, rich architectural character, and fully equipped hospitality infrastructure. Designed to operate seamlessly as both a boutique hotel and a private retreat, it blends natural materials with generous living spaces and panoramic outlooks.",
      },
      {
        type: "image",
        src: "/assets/images/house/faralya-estate/3.jpg",
        alt: "Faralya Estate",
      },
      {
        type: "blockquote",
        text: "DETAILED FEATURES — Accommodation & Interior Spaces",
      },
      {
        type: "list",
        items: [
          "10+ bedrooms, including independent guest rooms and bungalow-style units",
          "Most rooms feature en-suite bathrooms, with potential to add additional ones",
          "Combination of stone, wood, and large windows that maximise natural light",
          "Multiple lounges, indoor dining areas, and flexible gathering spaces",
          "Designed to function as both a hotel and a private estate",
          "Heating system installed for comfortable year-round living",
          "Large water tanks providing excellent storage capacity for long-term stays",
        ],
      },
      {
        type: "blockquote",
        text: "Outdoor Living & Retreat Facilities",
      },
      {
        type: "list",
        items: [
          "Expansive terraces on every floor, ideal for sunrise/sunset activities, yoga, meditation, or outdoor dining",
          "Large swimming pool with a generous sun deck",
          "Bungalows and independent guest units for privacy",
          "Changing rooms suitable for pool use, spa sessions, or wellness activities",
          "Large indoor and outdoor dining areas suitable for hosting groups",
          "Commercial-size kitchen with ample preparation and storage areas",
          "Mature fruit trees, Mediterranean landscaping, and irrigation-supported gardens",
          "Multiple seating areas, pergolas, and balconies with uninterrupted sea views",
        ],
      },
      {
        type: "image",
        src: "/assets/images/house/faralya-estate/21.jpg",
        alt: "Faralya Estate",
      },
      {
        type: "blockquote",
        text: "POTENTIAL & INVESTMENT OPPORTUNITIES",
      },
      {
        type: "list",
        items: [
          "Yoga & wellness retreat centre with ideal layouts for meditation, detox, sound healing, pilates or fitness programs",
          "Boutique hotel or eco-lodge with existing infrastructure that requires minimal upgrades",
          "Luxury rental estate suited for group stays in the Faralya–Kabak–Ölüdeniz region",
          "Private family compound offering privacy, nature, and extensive guest capacity",
          "Event or workshop venue suitable for weddings, corporate retreats, cooking classes or artistic residencies",
        ],
      },
      {
        type: "blockquote",
        text: "LOCATION",
      },
      {
        type: "list",
        items: [
          "Nearby: Butterfly Valley",
          "Nearby: Kabak Bay",
          "Nearby: Lycian Way hiking routes",
          "Nearby: Ölüdeniz and the world-famous blue lagoon",
          "Nearby: Fethiye centre with full amenities",
          "Located in Faralya, surrounded by greenery and panoramic sea views—known for luxury retreats and eco-lifestyle living",
        ],
      },
      {
        type: "image",
        src: "/assets/images/house/faralya-estate/4.jpg",
        alt: "Faralya Estate",
      },
      {
        type: "blockquote",
        text: "SUMMARY",
      },
      {
        type: "paragraph",
        text: "A rare opportunity in Faralya: an expansive estate with extraordinary sea views, extensive accommodation, mature landscaping, and flexible usage possibilities. Whether envisioned as a boutique hospitality investment, a wellness retreat, or a private sanctuary, this property offers unmatched scale, character, and potential in one of the most tranquil settings along the Turkish Riviera.",
      },
    ],
    PortfolioList2: getPortfolioImages("faralya-estate"),
  },
  {
    slug: "faralya-court",
    itype: "house",
    imageCount: 35,
    title: "Faralya Court",
    secondTitle: "£ 1,230,000",
    description: "FARALYA, FETHİYE",
    detailTitle: " Stone Villas with Shared Garden",
    detailDescription:
      "Authentic Stone Villas with Breathtaking Sea Views in an ideal location for investment.",
    beds: 15,
    baths: 15,
    area: "1003 m2",
    content: [
      {
        type: "paragraph",
        text: "Perched on the tranquil hillsides of Faralya, overlooking the glittering turquoise waters of the Mediterranean, this enchanting collection of traditional stone villas offers a rare opportunity to experience peace, privacy, and natural beauty in one of Turkey’s most stunning coastal locations. Blending timeless Mediterranean design with modern comfort, these villas represent the essence of refined living on the Turquoise Coast.",
      },
      {
        type: "paragraph",
        text: "Set on a spacious 1003 m² private plot, the property consists of several beautifully built villas nestled among mature pine trees and lush greenery. Each home features elegant stone and wood architecture, classic terracotta-tiled roofs, and panoramic sea and forest views that can be enjoyed from nearly every window and terrace. The setting is both private and inspiring — a place where the sea, sky, and nature converge in perfect harmony.",
      },
      {
        type: "image",
        src: "/assets/images/house/faralya-court/1.jpg",
        alt: "Serenity Villa Exterior",
      },
      {
        type: "paragraph",
        text: "Inside, the villas have been thoughtfully designed to combine warmth and functionality. The open-plan living areas are bright and welcoming, with large windows and doors that invite natural light and cooling sea breezes. The interiors feature tasteful finishes, natural textures, and a seamless connection between indoor and outdoor spaces — ideal for relaxed Mediterranean living.",
      },
      {
        type: "blockquote",
        text: "The heart of the property is the shared swimming pool and sun terrace, surrounded by stone pathways, flowering gardens, and shaded seating areas. This inviting communal space provides a serene environment for residents to unwind, swim, or enjoy the magnificent sunsets that Faralya is famous for. The atmosphere is tranquil and private, perfect for those who value peace and a strong connection to nature.",
      },
      {
        type: "image",
        src: "/assets/images/house/faralya-court/11.jpg",
        alt: "Villa Interior",
      },
      {
        type: "paragraph",
        text: "Each villa also enjoys private balconies or terraces, where residents can dine al fresco or simply take in the breathtaking views of the sea and surrounding pine forests. Whether you’re seeking a romantic retreat, a family getaway, or an investment property, these villas deliver an unmatched blend of charm, comfort, and scenery.",
      },
      {
        type: "list",
        items: [
          "Property Highlights",
          "Located in Faralya, Fethiye",
          "Total Plot Size: 1003 m²",
          "Collection of Traditional Stone Villas",
          "Breathtaking Sea and Forest Views",
          "Shared Swimming Pool & Landscaped Gardens",
          "Spacious Terraces and Balconies",
          "Natural Stone and Terracotta Architecture",
          "Peaceful, Elevated Location Surrounded by Pine Trees",
          "Close to Ölüdeniz, Butterfly Valley & Fethiye Town",
          "Ideal as a Private Residence or Boutique Investment",
        ],
      },
    ],

    PortfolioList2: getPortfolioImages("faralya-court"),
  },
  {
    slug: "villa-cooper",
    itype: "house",
    imageCount: 20,
    title: "Villa Cooper",
    secondTitle: "£ 795,000",
    description: "CALIS, FETHİYE",
    detailTitle: "Timeless Mediterranean Villa",
    detailDescription:
      "Charming Mediterranean-Style Villa with Private Pool and Lush Gardens",
    beds: 4,
    baths: 2,
    area: "700 m2",
    mainImage: "/assets/images/house/villa-cooper/14.jpg",

    content: [
      {
        type: "paragraph",
        text: "Discover timeless Mediterranean elegance in this beautifully presented 4-bedroom villa, perfectly positioned in the peaceful and highly desirable area of Calis, Fethiye. Blending classic stonework, terracotta accents, and vibrant bougainvillea, this home radiates warmth, character, and comfort — the ideal retreat for those seeking tranquillity by the sea.",
      },
      {
        type: "paragraph",
        text: "Set on a generous 700 m² private plot, this villa offers a harmonious balance of indoor and outdoor living. The home’s graceful architecture reflects traditional Mediterranean style, while inside you’ll find bright, modern spaces thoughtfully designed for relaxation and entertaining. The ground floor features an inviting open-plan living and dining area that opens directly onto the terrace and garden, filling the home with natural light and fresh air.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-cooper/1.jpg",
        alt: "Serenity Villa Exterior",
      },
      {
        type: "paragraph",
        text: "The fully equipped kitchen combines functionality with charm, offering ample workspace and direct access to the shaded outdoor dining area — perfect for summer evenings spent with family and friends. The villa’s spacious veranda, wrapped in lush greenery, provides a serene setting for morning coffee, afternoon reading, or enjoying the poolside breeze.",
      },
      {
        type: "blockquote",
        text: "Outdoors, a large private swimming pool is framed by a meticulously landscaped garden filled with palm trees, flowering plants, and stone pathways. The expansive terrace surrounding the pool offers plenty of room for sunbathing, entertaining, or simply soaking up the peaceful Mediterranean ambiance. The property’s generous 700 m² plot ensures full privacy while maintaining a sense of openness and space rarely found in the area.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-cooper/18.jpg",
        alt: "Villa Interior",
      },
      {
        type: "paragraph",
        text: "The upper floor hosts four comfortable bedrooms, including a charming master suite with a private balcony overlooking the garden and pool. Each bedroom is designed with comfort and natural light in mind, creating a calm and restful atmosphere. The villa’s tasteful interiors, neutral tones, and high-quality finishes ensure a timeless and elegant aesthetic throughout.",
      },
      {
        type: "list",
        items: [
          "Property Highlights",
          "4 Bedrooms | 3 Bathrooms",
          "Set on a 700 m² Private Plot",
          "Private Swimming Pool & Landscaped Garden",
          "Mediterranean Stone & Tile Architecture",
          "Spacious Open-Plan Living & Kitchen Area",
          "Large Outdoor Terrace & Covered Dining Space",
          "Private Balconies with Garden & Pool Views",
          "Peaceful Residential Setting in Calis",
          "Walking Distance to Beach, Shops & Restaurants",
          "Ideal for Family Living or Holiday Investmen",
        ],
      },
    ],

    PortfolioList2: getPortfolioImages("villa-cooper"),
  },
  {
    slug: "villa-arslan",
    itype: "house",
    imageCount: 26,
    title: "Villa Arslan",
    secondTitle: "£ 710,000",
    description: "FARALYA, FETHİYE",
    detailTitle: "Exclusive Sea-View Villa in Faralya",
    detailDescription: "Space, Privacy & Exceptional Investment Value",
    beds: 3,
    baths: 4,
    area: "805 m2",
    mainImage: "/assets/images/house/villa-arslan/17.jpg",

    content: [
      {
        type: "paragraph",
        text: "If you’re searching for a property that combines panoramic sea views, generous living space, and serious investment potential, this villa delivers on every level. Positioned on an impressive 805 sqm private plot in the tranquil hills of Faralya, this home offers uninterrupted sea views from the garden and every room, creating a constant connection to the Mediterranean landscape.",
      },
      {
        type: "paragraph",
        text: "This is not just another villa—it’s a high-performing lifestyle investment in one of Turkey’s most desirable coastal locations.",
      },
      {
        type: "paragraph",
        text: "The villa is designed for comfort, scale and modern living.",
      },
      {
        type: "blockquote",
        text: "With 220 sqm of enclosed living space, the villa has been thoughtfully designed to maximize light, openness, and functionality:",
      },
      {
        type: "list",
        items: [
          "3 spacious bedrooms, all generously proportioned",
          "A standout master suite featuring a private jacuzzi and TV, ideal for luxury living or high-end rental appeal",
          "4 modern bathrooms, providing convenience and flexibility for families or guests",
          "Expansive open-plan living room and kitchen area, perfect for entertaining or relaxed day-to-day living",
          "Large windows and doors that frame the sea views and bring natural light into every corner",
          "Underfloor heating throughout, ensuring year-round comfort and adding significant long-term value",
        ],
      },
      {
        type: "paragraph",
        text: "The interior layout is ideal for both private use and short-term rental, offering a seamless balance between comfort and practicality.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-arslan/23.jpg",
        alt: "Villa Arslan",
      },
      {
        type: "blockquote",
        text: "Step outside and you’ll find a setting designed to impress:",
      },
      {
        type: "list",
        items: [
          "A large private swimming pool as the centerpiece of the outdoor space",
          "A second smaller pool, already prepared and ready to be completed—an excellent opportunity to instantly increase property value",
          "Multiple large balconies, all offering stunning, uninterrupted sea views",
          "A beautifully arranged garden with a dedicated vegetable patch, perfect for sustainable living",
          "BBQ and outdoor dining area, ideal for hosting guests or enjoying long summer evenings",
          "Stone walls and landscaped elements that create a sense of privacy and character",
          "Private garage for convenience and security",
        ],
      },
      {
        type: "paragraph",
        text: "The outdoor areas are perfectly suited for entertaining, relaxing, or maximizing rental appeal, making this property as functional as it is visually striking.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-arslan/5.jpg",
        alt: "Villa Arslan",
      },
      {
        type: "blockquote",
        text: "Strong Investment & Rental Potential",
      },
      {
        type: "paragraph",
        text: "Faralya has become one of the most sought-after destinations on the Turkish Riviera, known for its natural beauty, exclusivity, and proximity to iconic locations such as Butterfly Valley and the Blue Lagoon.",
      },
      {
        type: "paragraph",
        text: "This villa is particularly well-positioned to capitalize on that demand:",
      },
      {
        type: "list",
        items: [
          "High appeal for luxury holiday rentals and boutique stays",
          "Sea views from every room—a rare and highly marketable feature",
          "Spacious layout ideal for families, groups, or premium guests",
          "Opportunity to enhance value further by completing the second pool",
          "Strong potential for high seasonal rental income and long-term appreciation",
        ],
      },
      {
        type: "paragraph",
        text: "Whether you plan to use the property privately, rent it out, or do both, it offers flexibility with clear financial upside.",
      },
      {
        type: "paragraph",
        text: "Beyond the numbers, this villa offers something harder to quantify:",
      },
      {
        type: "blockquote",
        text: "Peace, privacy, and a front-row seat to some of the most beautiful views in the region.",
      },

      {
        type: "paragraph",
        text: "Wake up to the sea, enjoy sunsets from your balcony, and experience a slower, more refined pace of life—while still being within reach of beaches, nature, and local amenities.",
      },
      {
        type: "list",
        items: [
          "805 sqm plot | 220 sqm interior",
          "3 bedrooms | 4 bathrooms",
          "Master suite with jacuzzi & TV",
          "Large pool + second pool ready",
          "Sea views from all rooms & garden",
          "Spacious balconies",
          "BBQ area & landscaped garden with vegetable patch",
          "Garage",
          "Underfloor heating",
        ],
      },
      {
        type: "image",
        src: "/assets/images/house/villa-arslan/12.jpg",
        alt: "Villa Arslan",
      },
      {
        type: "blockquote",
        text: "This is a rare opportunity to secure a premium villa in Faralya with both lifestyle appeal and strong investment credentials.",
      },
      {
        type: "paragraph",
        text: "Contact now to arrange a viewing or request further details—properties with this level of space, views, and potential are in high demand and limited supply.",
      },
    ],

    PortfolioList2: getPortfolioImages("villa-arslan"),
  },
  {
    slug: "villa-zana",
    itype: "house",
    imageCount: 26,
    title: "Villa Zana",
    secondTitle: "£ 590,000",
    description: "FARALYA, FETHİYE",
    detailTitle: "Luxury Mediterranean Villa in Faralya",
    detailDescription:
      "Impressive 6-Bedroom Sea-View Villa with Private Pool, Expansive Terraces & Landscaped Garden — Minutes from Kabak and Ölüdeniz",
    mainImage: "/assets/images/house/villa-zana/18.jpg",
    beds: 6,
    baths: 6,
    area: "654 m2",
    content: [
      {
        type: "paragraph",
        text: "Set in the beautiful and sought-after area of Faralya, Fethiye, this impressive villa offers an exceptional combination of privacy, space, panoramic Mediterranean views, and easy access to some of the region’s most famous beaches.",
      },
      {
        type: "paragraph",
        text: "Situated on a generous 654 m² private plot, the property provides approximately 350 m² of indoor living space, complemented by expansive terraces and a beautifully designed garden with a large private swimming pool.",
      },
      {
        type: "paragraph",
        text: "From the villa’s multiple levels, terraces, and rooms, you can enjoy stunning views towards the Mediterranean Sea and surrounding natural landscape.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-zana/1.jpg",
        alt: "Villa Zana Living Room",
      },
      {
        type: "blockquote",
        text: "Property Highlights",
      },
      {
        type: "list",
        items: [
          "654 m² private plot",
          "350 m² indoor living area",
          "6 spacious bedrooms",
          "6 bathrooms",
          "2 fully equipped kitchens",
          "Large and comfortable living room",
          "Private swimming pool",
          "Large landscaped garden",
          "Multiple spacious terraces",
          "Panoramic Mediterranean Sea views",
          "Views from every room and terrace",
          "Underfloor heating",
          "Excellent indoor/outdoor living spaces",
          "Private and peaceful setting",
        ],
      },
      {
        type: "paragraph",
        text: "The villa has been thoughtfully designed across several levels, with large windows bringing in abundant natural light and allowing the spectacular surroundings to be enjoyed from almost every part of the home. The generous terraces provide ideal spaces for outdoor dining, relaxing, and entertaining while taking in the sea views.",
      },
      {
        type: "paragraph",
        text: "The large pool area creates a wonderful private setting for enjoying the long Mediterranean summers, while the spacious garden offers plenty of room for family and guests.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-zana/9.jpg",
        alt: "Villa Zana Terrace with Sea View",
      },
      {
        type: "blockquote",
        text: "Prime Location",
      },
      {
        type: "paragraph",
        text: "The villa is ideally positioned for enjoying the natural beauty of the Fethiye region. Kabak Beach and Ölüdeniz Beach are both approximately a 15-minute drive away, giving you easy access to some of Turkey’s most beautiful coastline.",
      },
      {
        type: "paragraph",
        text: "Faralya itself is renowned for its peaceful atmosphere, dramatic scenery, Mediterranean coastline, and proximity to the famous Lycian Way.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-zana/23.jpg",
        alt: "Villa Zana Panoramic Mediterranean View",
      },
      {
        type: "blockquote",
        text: "An Exceptional Mediterranean Retreat",
      },
      {
        type: "paragraph",
        text: "Whether you are looking for a luxury family residence, private holiday home, or high-quality investment property, this villa offers an outstanding opportunity to own a substantial property in one of the most desirable areas around Fethiye.",
      },
      {
        type: "paragraph",
        text: "With its generous plot, extensive living space, private pool, six bedrooms, multiple terraces, and uninterrupted connection to the surrounding landscape, this is a property designed to make the most of Mediterranean living.",
      },
      {
        type: "paragraph",
        text: "A rare opportunity to own a spacious sea-view villa in Faralya, just minutes from Kabak and Ölüdeniz. For further information or to arrange a private viewing, please contact us.",
      },
    ],

    PortfolioList2: getPortfolioImages("villa-zana", 26),
  },
  {
    slug: "villa-barisdeniz",
    itype: "house",
    imageCount: 10,
    title: "Villa Barışdeniz",
    secondTitle: "£ 630,000",
    description: "OVACIK, FETHİYE",
    detailTitle: "Contemporary Villa in Ovacık",
    detailDescription:
      "Stunning 4-Bedroom Luxury Villa with Panoramic Views of Ölüdeniz, Babadağ, Fethiye Bay & Mendos Mountain",
    mainImage: "/assets/images/house/villa-barisdeniz/3.jpg",
    beds: 4,
    baths: 4,
    area: "753 m2",
    content: [
      {
        type: "paragraph",
        text: "Located in the prestigious and peaceful area of Ovacık, one of Fethiye’s most sought-after residential destinations, this exceptional villa offers a unique combination of modern architecture, spacious living areas, breathtaking views, and beautifully landscaped gardens.",
      },
      {
        type: "paragraph",
        text: "Set on a 753 m² plot with 260 m² of net indoor living space, the property is one of the rare villas in the region where you can enjoy sea, mountain, and nature views all at once. Every room and balcony benefits from spectacular views of Ölüdeniz, Fethiye Bay, and Babadağ, while the rear aspect overlooks the tranquil Mendos Mountain and surrounding forest.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-barisdeniz/1.jpg",
        alt: "Villa Barışdeniz",
      },
      {
        type: "blockquote",
        text: "Property Features",
      },
      {
        type: "list",
        items: [
          "753 m² plot size",
          "260 m² net internal living area",
          "4 spacious bedrooms",
          "4 bathrooms",
          "Home office / study room",
          "Bright and spacious living room",
          "Large modern kitchen",
          "Pantry and storage areas",
          "Air conditioning in all rooms",
          "Underfloor heating system",
          "Security camera system",
          "Separate annex / additional utility space",
          "Private parking for 2 vehicles",
        ],
      },
      {
        type: "image",
        src: "/assets/images/house/villa-barisdeniz/5.jpg",
        alt: "Villa Barışdeniz Interior",
      },
      {
        type: "blockquote",
        text: "Outdoor Features",
      },
      {
        type: "list",
        items: [
          "Private swimming pool",
          "Professionally landscaped terraced garden",
          "Pergola and shaded relaxation area",
          "Multiple outdoor seating areas",
          "Mature ornamental plants and attractive landscaping",
          "Private grounds enclosed by natural stone walls",
        ],
      },
      {
        type: "blockquote",
        text: "Spectacular Views",
      },
      {
        type: "paragraph",
        text: "This unique villa offers stunning scenery throughout the day, including:",
      },
      {
        type: "list",
        items: [
          "Ölüdeniz views",
          "Fethiye town and bay views",
          "Babadağ mountain views",
          "Panoramic sea views",
          "Mendos Mountain views",
          "Forest and natural landscape views",
        ],
      },
      {
        type: "image",
        src: "/assets/images/house/villa-barisdeniz/9.jpg",
        alt: "Villa Barışdeniz Outdoor Living Area",
      },
      {
        type: "blockquote",
        text: "Prime Location",
      },
      {
        type: "paragraph",
        text: "Situated in one of Ovacık’s most exclusive and tranquil neighborhoods, the villa benefits from:",
      },
      {
        type: "list",
        items: [
          "Easy access to Fethiye town centre",
          "Short driving distance to the world-famous Ölüdeniz Beach",
          "Close proximity to supermarkets, restaurants, and daily amenities",
          "Strong rental income potential",
          "Excellent long-term investment value",
        ],
      },
      {
        type: "blockquote",
        text: "Your Dream Lifestyle Awaits",
      },
      {
        type: "paragraph",
        text: "Combining contemporary design, extraordinary views, generous living spaces, and meticulously maintained outdoor areas, this exceptional villa is the perfect choice for those seeking a luxurious year-round residence, a holiday home, or a high-yield investment opportunity in one of Turkey’s most desirable coastal destinations.",
      },
      {
        type: "paragraph",
        text: "For further information or to arrange a private viewing, please contact us.",
      },
    ],

    PortfolioList2: getPortfolioImages("villa-barisdeniz", 10),
  },
  {
    slug: "villa-pars",
    itype: "house",
    imageCount: 13,
    title: "Villa Pars",
    secondTitle: "£ 570,000",
    description: "AKARCA, FETHİYE",
    detailTitle: "Refined Luxury Living in Akarca",
    detailDescription: "An Exceptional 4-Bedroom Villa",
    mainImage: "/assets/images/house/villa-pars/16.jpg",
    beds: 4,
    baths: 4,
    area: "591 m2",
    content: [
      {
        type: "paragraph",
        text: "In one of Fethiye’s most prestigious and tightly held residential enclaves, this distinguished villa in Akarca represents a rare opportunity to secure a home that seamlessly blends scale, elegance, and location. Known for its wide, tree-lined streets, proximity to the coastline, and relaxed yet upscale atmosphere, Akarca continues to be one of the most desirable addresses in the region—favored by those seeking both privacy and effortless access to daily life.",
      },
      {
        type: "paragraph",
        text: "Set within a generous 591 m² private plot, the villa offers an impressive 260 m² of refined internal living space, carefully designed to deliver both comfort and understated luxury. From the moment you arrive, the property conveys a sense of presence, with its balanced architecture, private boundaries, and mature greenery framing the home.",
      },
      {
        type: "paragraph",
        text: "Inside, the villa opens into a substantial, light-filled living room, where large windows invite natural light throughout the day, enhancing the feeling of openness and calm. The spacious, well-appointed kitchen has been designed as both a functional workspace and a social hub, ideal for entertaining guests or enjoying relaxed family moments. The flow between living areas is intuitive and harmonious, creating a home that feels both expansive and welcoming.",
      },
      {
        type: "paragraph",
        text: "Extending from the main living spaces is a generous terrace, offering an elegant transition between indoors and out. This space is perfectly suited for al fresco dining, long summer evenings, or simply enjoying the peaceful surroundings of the garden. Whether hosting guests or seeking quiet retreat, the terrace becomes a natural extension of the home’s lifestyle appeal.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-pars/1.jpg",
        alt: "Villa Pars",
      },
      {
        type: "paragraph",
        text: "The villa features four beautifully proportioned bedrooms, each offering comfort, privacy, and flexibility. Accompanied by four well-finished bathrooms, the home is ideally suited for families or those who frequently host, ensuring a high level of convenience and personal space for all occupants.",
      },
      {
        type: "paragraph",
        text: "Attention to comfort is evident throughout, with underfloor heating installed across the entire property, providing a consistent and luxurious living environment during the cooler months—an increasingly sought-after feature in high-end homes.",
      },
      {
        type: "paragraph",
        text: "Outdoors, the expansive private garden is both a sanctuary and an opportunity. Landscaped with mature planting and offering generous open areas, it provides ample space for leisure, recreation, or the addition of a bespoke swimming pool, outdoor kitchen, or wellness area. The scale of the plot ensures privacy while still allowing flexibility for future enhancements, making it equally appealing for lifestyle buyers and investors.",
      },
      {
        type: "paragraph",
        text: "A private garage adds both practicality and security, completing a property that has been designed to accommodate modern living without compromise.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-pars/11.jpg",
        alt: "Villa Pars",
      },
      {
        type: "blockquote",
        text: "Key Highlights",
      },
      {
        type: "list",
        items: [
          "Prestigious location in Akarca, one of Fethiye’s most sought-after neighborhoods",
          "Short walk to the promenade, seafront, and local amenities",
          "260 m² of elegant, light-filled interior living space",
          "591 m² private plot with mature landscaping",
          "Expansive living room and large, fully functional kitchen",
          "Seamless indoor-outdoor flow with a generous terrace area",
          "4 spacious bedrooms and 4 well-appointed bathrooms",
          "Underfloor heating throughout for year-round comfort",
          "Large garden with potential for pool and luxury outdoor features",
          "Private garage and secure setting",
        ],
      },
      {
        type: "image",
        src: "/assets/images/house/villa-pars/14.jpg",
        alt: "Villa Pars",
      },
      {
        type: "paragraph",
        text: "This exceptional villa offers more than just a home—it delivers a lifestyle defined by space, comfort, and location. Whether envisioned as a full-time residence, a refined holiday retreat, or a high-quality investment in one of Fethiye’s most stable and desirable areas, the property stands out as a compelling and enduring opportunity.",
      },
      {
        type: "paragraph",
        text: "For buyers seeking a residence that combines elegance with everyday practicality, in a setting that continues to grow in both prestige and value, this Akarca villa is truly worthy of consideration.",
      },
    ],

    PortfolioList2: getPortfolioImages("villa-pars"),
  },
  {
    slug: "villa-kalkan",
    itype: "house",
    imageCount: 19,
    title: "Kalkan Villas",
    secondTitle: "£ 570,000",
    description: "KALKAN, ANTALYA",
    detailTitle: "Luxury Villa with Sea Views for Sale in Kalkan",
    detailDescription:
      "A spacious designer villa with sea views, private pool, landscaped garden, and exceptional wellness facilities",
    mainImage: "/assets/images/house/villa-kalkan/1.jpg",
    beds: 4,
    baths: 5,
    area: "500 m2",
    content: [
      {
        type: "paragraph",
        text: "Set in one of Kalkan’s sought-after villa areas, this impressive contemporary property combines generous living spaces, outdoor entertaining areas, and a comprehensive range of luxury features. With a 500 m² plot share and 257 m² of net interior living space (300 m² gross), the villa offers an ideal setting for both private holidays and year-round living.",
      },
      {
        type: "paragraph",
        text: "Large terraces overlook the private swimming pool and surrounding landscape, while the elevated position provides beautiful sea views. The landscaped garden is equipped with an automatic irrigation system, creating an attractive and easy-to-maintain outdoor environment.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-kalkan/2.jpg",
        alt: "Kalkan Villas",
      },
      {
        type: "blockquote",
        text: "Property Highlights",
      },
      {
        type: "list",
        items: [
          "500 m² plot share",
          "300 m² gross building area",
          "257 m² net interior living area",
          "4 bedrooms + living room",
          "5 WC / bathrooms",
          "Sea views",
          "Private swimming pool",
          "Landscaped garden with automatic irrigation",
          "Outdoor parking",
          "Spacious shaded terraces",
          "BBQ and outdoor entertaining area",
          "Fully furnished",
          "Appliances included",
          "Underfloor heating",
          "Automatic shutters",
          "Private Turkish bath (Hamam)",
          "Private sauna",
          "Multiple balconies and terraces",
          "Contemporary architectural design",
        ],
      },
      {
        type: "blockquote",
        text: "Outdoor Living",
      },
      {
        type: "paragraph",
        text: "The villa has been designed around outdoor living, with a large private swimming pool surrounded by sun terraces and comfortable loungers. A covered BBQ and dining area provides a shaded space for entertaining, while the landscaped lawn and terraces offer plenty of room to relax and enjoy the Kalkan climate.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-kalkan/10.jpg",
        alt: "Kalkan Villas",
      },
      {
        type: "blockquote",
        text: "Interior & Wellness",
      },
      {
        type: "paragraph",
        text: "Inside, the property offers 257 m² of net living space, with contemporary finishes, generous glazing and direct access to the outdoor areas. The villa is equipped with underfloor heating and automatic shutters, providing comfort and convenience throughout the year.",
      },
      {
        type: "paragraph",
        text: "For those looking to relax at home, the dedicated Hamam and sauna create a private wellness area, making this more than simply a holiday villa.",
      },
      {
        type: "blockquote",
        text: "An Ideal Kalkan Home",
      },
      {
        type: "paragraph",
        text: "Combining sea views, substantial living space, a private pool, landscaped grounds and luxury wellness facilities, this villa offers a turnkey opportunity in Kalkan. Being sold fully furnished with appliances included, it is ready to be enjoyed as a private residence, holiday home or rental property.",
      },
      {
        type: "paragraph",
        text: "A beautifully presented Kalkan villa offering contemporary style, generous outdoor space and a true Mediterranean lifestyle.",
      },
    ],

    PortfolioList2: getPortfolioImages("villa-kalkan", 19),
  },
  {
    slug: "villa-yolcu",
    itype: "house",
    imageCount: 13,
    title: "Villa Yolcu",
    secondTitle: "£ 480,000",
    description: "FARALYA, FETHİYE",
    detailTitle: "Mediterranean Stone Villa with Sea Views in Faralya",
    detailDescription: "Private pool • Sea views • Private driveway/parking",
    mainImage: "/assets/images/house/villa-yolcu/13.jpg",
    beds: 4,
    baths: 3,
    area: "572 m2",
    content: [
      {
        type: "blockquote",
        text: "Overview",
      },
      {
        type: "paragraph",
        text: "Set on a tranquil 572 m² plot above the turquoise coast, this character-filled 4-bedroom, 3-bathroom villa blends natural-stone architecture with wide sliding glass doors and vine-draped pergolas for true indoor–outdoor living. The home captures sweeping sea and sunset views and offers complete privacy—ideal for year-round living, a luxury holiday base, or a high-performing rental.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-yolcu/8.jpg",
        alt: "Villa Yolcu",
      },
      {
        type: "blockquote",
        text: "Key Features",
      },
      {
        type: "list",
        items: [
          "Private swimming pool with generous sun terraces and lounging zones",
          "Expansive sea views across the Faralya coastline and surrounding hills",
          "Open-plan living/dining with full-height doors that open directly to the pool terrace",
          "4 comfortable bedrooms, including a principal suite with terrace access",
          "3 modern bathrooms ",
          "Private driveway with on-plot parking",
          "Stone façade, timber details, and mature landscaping with bougainvillea and climbers",
          "Air-conditioning and quality glazing for year-round comfort",
        ],
      },
      {
        type: "blockquote",
        text: "Layout",
      },
      {
        type: "paragraph",
        text: "Ground floor: Bright open-plan lounge/dining area and kitchen spilling out to the pool terrace, one guest bedroom, and a full bathroom. Upper level: Three bedrooms (including the principal suite) and two bathrooms. Balconies/terraces on this level frame the sea and garden views, perfect for morning coffee and sunset aperitifs.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-yolcu/5.jpg",
        alt: "Villa Yolcu",
      },
      {
        type: "blockquote",
        text: "Outdoor Living",
      },
      {
        type: "paragraph",
        text: "Designed for long Mediterranean days, the exterior offers a large pool with mosaic detailing, shaded dining and lounging areas, herb/flower beds, and stone pathways. The private driveway provides easy access and secure parking, a rare convenience in the hills of Faralya.",
      },
      {
        type: "blockquote",
        text: "Location",
      },
      {
        type: "paragraph",
        text: "Peaceful yet connected, the villa sits minutes from Faralya’s boutique hotels, beach platforms, and Lycian Way walking routes, with Ölüdeniz and Fethiye reachable by scenic drive for marinas, restaurants, and everyday amenities.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-yolcu/2.jpg",
        alt: "Villa Yolcu",
      },
      {
        type: "blockquote",
        text: "Investment & Lifestyle",
      },
      {
        type: "paragraph",
        text: "Faralya’s limited supply of sea-view stone villas ensures enduring appeal. With its pool, parking, and view-forward design, this property is well positioned for premium rental yields or as a low-maintenance private retreat.",
      },
      {
        type: "blockquote",
        text: "Ready to view?",
      },
      {
        type: "paragraph",
        text: "Get in touch for the full photo set, floor plan, and to arrange a private tour.",
      },
    ],
    videoPic: "/assets/images/house/villa-yolcu/10.jpg",
    videoId: "rXikO4nxAoI",
    videoText: "",
    PortfolioList2: getPortfolioImages("villa-yolcu"),
  },
  {
    slug: "villa-mudo",
    itype: "house",
    imageCount: 59,
    title: "Villa Mudo",
    secondTitle: "£ 645,000",
    description: "FARALYA, FETHİYE",
    detailTitle: "Exceptional Luxury Sea-View Villa",
    detailDescription:
      "A distinct property for those seeking a refined living environment.",
    mainImage: "/assets/images/house/villa-mudo/25.jpg",
    beds: 4,
    baths: 4,
    area: "500 m2",
    content: [
      {
        type: "paragraph",
        text: "Perched on the elevated slopes of Faralya, one of Fethiye’s most exclusive and visually striking locations, this outstanding villa offers a rare combination of architectural elegance, uninterrupted Mediterranean Sea views, and complete privacy. Set on a 500 m² multi-tiered plot, the property has been carefully designed to follow the natural contours of the land, ensuring that the sea is visible from the garden, terraces, and every interior space of the house.",
      },
      {
        type: "paragraph",
        text: "The villa comprises 4 generously sized bedrooms and 4 contemporary bathrooms, each designed with comfort, natural light, and views as a priority. Floor-to-ceiling windows frame the surrounding landscape, allowing the blue of the Mediterranean and the green of the mountains to become part of the interior experience. The layout is ideal both for permanent living and for hosting guests, offering a sense of separation and privacy between sleeping and social areas.",
      },
      {
        type: "paragraph",
        text: "Outdoor living is one of the villa’s defining features. Thanks to the multi-level garden design, the property offers a variety of distinct spaces: expansive sea-facing terraces, a stylish BBQ and outdoor dining area, shaded lounging corners, and a stunning private swimming pool positioned to overlook the coastline. Whether enjoying quiet mornings with panoramic views or entertaining guests at sunset, the outdoor areas are designed to fully embrace Faralya’s natural beauty.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-mudo/25.jpg",
        alt: "Villa Mudo",
      },
      {
        type: "blockquote",
        text: "Property Highlights",
      },
      {
        type: "list",
        items: [
          "Prime location in Faralya, Fethiye, one of the region’s most exclusive and scenic mountain villages",
          "500 m² multi-tiered plot, designed to follow the natural landscape",
          "Panoramic Mediterranean Sea views from the garden, all terraces, and every room",
          "Elevated position ensuring privacy, open views, and low-density surroundings",
        ],
      },
      {
        type: "paragraph",
        text: "Inside, the villa is equipped with a range of high-end lifestyle and wellness features. A private gym and sauna create a spa-like atmosphere at home, while the dedicated cinema room offers a true luxury entertainment experience. A modern heating and cooling system ensures year-round comfort, making the property equally suitable for summer holidays or full-time residence.",
      },
      {
        type: "paragraph",
        text: "Sustainability and efficiency are key strengths of this home. The villa is fitted with solar panels that actively produce electricity, significantly reducing energy costs while supporting environmentally conscious living—an increasingly valuable asset in premium real estate. High-quality construction materials and thoughtful engineering further enhance long-term value and comfort.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-mudo/23.jpg",
        alt: "Villa Mudo",
      },
      {
        type: "blockquote",
        text: "Villa Features",
      },
      {
        type: "list",
        items: [
          "4 spacious bedrooms, all with sea views",
          "4 modern bathrooms with high-quality finishes",
          "Bright, open-plan living spaces with large windows and natural light",
          "Multiple sea-facing terraces for outdoor living and relaxation",
          "Landscaped, multi-level garden with distinct leisure areas     ",
        ],
      },
      {
        type: "paragraph",
        text: "Located just 15 km from the world-famous Ölüdeniz Beach, the villa offers the perfect balance between seclusion and accessibility. Faralya is known for its untouched landscapes, low-density development, and dramatic coastal views, making it one of the most desirable areas in the Fethiye region for discerning buyers seeking tranquility, prestige, and natural beauty.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-mudo/21.jpg",
        alt: "Villa Mudo",
      },
      {
        type: "paragraph",
        text: "This property is ideally suited as a luxury private residence, an exclusive holiday retreat, or a high-yield investment villa in a location where demand for premium homes consistently remains strong. Combining views, privacy, modern amenities, and sustainable features, this villa represents a truly rare opportunity in the Mediterranean property market.",
      },
      {
        type: "paragraph",
        text: "A distinctive home for those seeking refined living at the intersection of nature, comfort, and timeless coastal beauty.",
      },
      {
        type: "blockquote",
        text: "Outdoor & Leisure Areas",
      },
      {
        type: "list",
        items: [
          "Private swimming pool overlooking the Mediterranean",
          "Dedicated BBQ and outdoor dining area",
          "Shaded seating and sunbathing terraces",
          "Designed for both quiet enjoyment and entertaining guests",
        ],
      },
    ],

    PortfolioList2: getPortfolioImages("villa-mudo"),
  },
  {
    slug: "villa-palm",
    itype: "house",
    imageCount: 21,
    title: "Villa Palm",
    secondTitle: "£ 530,000",
    description: "KARAGOZLER, FETHİYE",
    detailTitle: "Tranquil House in the Heart of Fethiye",
    detailDescription: "Elegant Sea-View Villa in Karagözler, Fethiye",
    mainImage: "/assets/images/house/villa-palm/19.jpg",
    beds: 5,
    baths: 4,
    area: "200 m2",
    content: [
      {
        type: "paragraph",
        text: "Situated in the highly prestigious and centrally located Karagözler neighborhood of Fethiye, this spacious sea-view villa offers an exceptional lifestyle opportunity in one of the town’s most desirable residential areas. Known for its proximity to the marina, tranquil surroundings, and strong property values, Karagözler remains one of the most sought-after locations in Fethiye for both permanent living and investment.",
      },

      {
        type: "image",
        src: "/assets/images/house/villa-palm/18.jpg",
        alt: "Villa Palm",
      },
      {
        type: "paragraph",
        text: "Surrounded by mature palm trees, established villas, and lush greenery, the property enjoys a peaceful atmosphere while remaining just minutes away from Fethiye Marina, the town center, waterfront promenades, restaurants, cafés, and daily amenities.",
      },
      {
        type: "blockquote",
        text: "Property Overview",
      },
      {
        type: "list",
        items: [
          "Total internal living space: 200 m²",
          "4 spacious bedrooms",
          "1 main living room",
          "2 fully functional kitchens",
          "4 bathrooms",
          "Large sea-view terrace",
          "Multiple balconies",
          "Small private garden",
        ],
      },
      {
        type: "image",
        src: "/assets/images/house/villa-palm/13.jpg",
        alt: "Villa Palm",
      },
      {
        type: "paragraph",
        text: "The villa is arranged over multiple levels, offering a well-balanced layout that provides both privacy and generous communal living areas. Thanks to its thoughtful design and elevated position, the house benefits from abundant natural light and beautiful sea views from its terraces and upper floors.",
      },
      {
        type: "blockquote",
        text: "Interior Features",
      },
      {
        type: "paragraph",
        text: "The main living room is bright and welcoming, with direct access to outdoor areas, creating a seamless indoor–outdoor living experience. Large windows and balcony doors allow natural light to flow throughout the home while framing the surrounding greenery and sea.",
      },
      {
        type: "paragraph",
        text: "With two separate kitchens, the property is particularly well-suited for extended families, multi-generational living, or those seeking flexible usage options, including potential rental arrangements.",
      },
      {
        type: "paragraph",
        text: "All four bedrooms are generously sized, offering comfortable accommodation for family members and guests alike. The four bathrooms are conveniently distributed throughout the house, ensuring comfort and privacy on every level.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-palm/21.jpg",
        alt: "Villa Palm",
      },
      {
        type: "blockquote",
        text: "Outdoor Living",
      },
      {
        type: "paragraph",
        text: "One of the villa’s standout features is its large terrace area, offering an ideal space for outdoor dining, entertaining, or simply relaxing while enjoying the sea views and Fethiye’s mild Mediterranean climate.",
      },
      {
        type: "paragraph",
        text: "The small private garden, surrounded by mature plants and palm trees, adds to the sense of privacy and tranquility, creating a pleasant green retreat in a central location.",
      },
      {
        type: "blockquote",
        text: "Location Highlights – Karagözler, Fethiye",
      },
      {
        type: "paragraph",
        text: "Karagözler is widely regarded as one of Fethiye’s most elite residential districts. Properties in this area benefit from:",
      },
      {
        type: "list",
        items: [
          "Walking distance or short drive to Fethiye Marina",
          "Easy access to the town center and harbor",
          "Scenic coastal walking routes",
          "A quiet, well-established neighborhood",
          "Strong long-term investment potential",
        ],
      },
      {
        type: "paragraph",
        text: "Homes in Karagözler are in limited supply, making this an excellent opportunity for buyers seeking exclusivity, convenience, and enduring value.        ",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-palm/3.jpg",
        alt: "Villa Palm",
      },
      {
        type: "blockquote",
        text: "Ideal For",
      },
      {
        type: "list",
        items: [
          "Permanent year-round living",
          "Holiday home use",
          "Investment with strong rental demand",
          "Buyers seeking a central yet peaceful sea-view property",
        ],
      },
      {
        type: "blockquote",
        text: "Summary",
      },
      {
        type: "paragraph",
        text: "This 200 m² sea-view villa in Karagözler offers generous living space, flexible accommodation, and a prime location close to Fethiye’s marina and town center. With its large terrace, private garden, and prestigious setting, it represents a rare opportunity to own a quality property in one of Fethiye’s most desirable neighborhoods.",
      },
      {
        type: "paragraph",
        text: "Location: Karagözler, Fethiye.",
      },
      {
        type: "paragraph",
        text: "Sea View | Central Location | Prestigious Area",
      },
      {
        type: "paragraph",
        text: "For further information or to arrange a private viewing, please contact us.",
      },
    ],
    PortfolioList2: getPortfolioImages("villa-palm"),
  },
  {
    slug: "villa-sirena",
    itype: "house",
    imageCount: 20,
    title: "Sirena Villa",
    secondTitle: "£ 550,000",
    description: "ÇALIŞ, FETHİYE",
    detailTitle: "Luxury 4-Bedroom Detached Villa with Private Pool in Çalış",
    detailDescription:
      "A contemporary four-bedroom villa offering spacious interiors, private outdoor living and stunning mountain surroundings in the sought-after Çalış area of Fethiye",
    mainImage: "/assets/images/house/villa-sirena/12.jpg",
    beds: 4,
    baths: 4,
    area: "345 m2",
    content: [
      {
        type: "paragraph",
        text: "A contemporary four-bedroom villa offering spacious interiors, private outdoor living and stunning mountain surroundings in the sought-after Çalış area of Fethiye.",
      },
      {
        type: "paragraph",
        text: "Set on a 345 m² private plot, this beautifully designed 230 m² fully detached villa combines modern architecture with generous living spaces, a private swimming pool and landscaped outdoor areas. With four bedrooms, all with en-suite bathrooms, the property is ideally suited as a family home, holiday residence or investment property.",
      },
      {
        type: "paragraph",
        text: "The villa enjoys an abundance of natural light, large glass openings and spacious balconies and terraces overlooking the pool and surrounding scenery. The impressive mountain backdrop adds to the property's sense of space and tranquillity.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-sirena/2.jpg",
        alt: "Sirena Villa Living Room",
      },
      {
        type: "blockquote",
        text: "Key Features",
      },
      {
        type: "list",
        items: [
          "345 m² plot",
          "230 m² interior living area",
          "Fully detached villa",
          "Private swimming pool",
          "Condominium title deed",
          "Smart home system",
          "Security camera system",
          "Outdoor private parking",
          "Automatic garden irrigation system",
          "Windows fitted with shutters",
          "Landscaped garden and outdoor entertaining areas",
          "Modern kitchen and living spaces",
          "Four bedrooms, all with en-suite bathrooms",
          "Multiple balconies and large rooftop-style terraces",
          "Mountain views",
        ],
      },
      {
        type: "blockquote",
        text: "Ground Floor",
      },
      {
        type: "paragraph",
        text: "The ground floor provides a bright and spacious open-plan living environment, with the living room and modern kitchen opening directly onto the garden and private pool area.",
      },
      {
        type: "list",
        items: [
          "Spacious living room",
          "Open-plan kitchen",
          "Direct access to garden and pool",
          "Guest WC",
          "Entrance foyer / cloakroom",
        ],
      },
      {
        type: "blockquote",
        text: "First Floor",
      },
      {
        type: "paragraph",
        text: "The first floor features two generous bedrooms, each designed as a private suite.",
      },
      {
        type: "list",
        items: [
          "Bedroom 1: en-suite bathroom and private balcony",
          "Bedroom 2: en-suite bathroom and private balcony",
        ],
      },
      {
        type: "blockquote",
        text: "Second Floor",
      },
      {
        type: "paragraph",
        text: "The upper floor offers a further two en-suite bedrooms, each benefiting from access to a spacious terrace.",
      },
      {
        type: "list",
        items: [
          "Bedroom 3: en-suite bathroom and private terrace",
          "Bedroom 4: en-suite bathroom and private terrace",
        ],
      },
      {
        type: "image",
        src: "/assets/images/house/villa-sirena/5.jpg",
        alt: "Sirena Villa Private Pool and Garden",
      },
      {
        type: "blockquote",
        text: "Outdoor Living",
      },
      {
        type: "paragraph",
        text: "The private garden has been thoughtfully landscaped around the swimming pool, creating a peaceful setting for relaxing, dining and entertaining. The pool area benefits from excellent privacy, while the surrounding terraces provide plenty of space for outdoor furniture and sun loungers.",
      },
      {
        type: "paragraph",
        text: "The villa's elevated terraces and balconies also make the most of the spectacular mountain backdrop, giving the property a distinctive Fethiye feel.",
      },
      {
        type: "paragraph",
        text: "Located in Çalış, one of Fethiye's popular residential and holiday areas, the villa offers the combination of a peaceful residential setting and easy access to the area's amenities, coastline, restaurants and everyday services.",
      },
      {
        type: "paragraph",
        text: "A modern, spacious and private four-bedroom villa with its own pool, generous outdoor space and beautiful mountain surroundings — an excellent opportunity for those looking for a contemporary home in Çalış, Fethiye.",
      },
    ],

    PortfolioList2: getPortfolioImages("villa-sirena", 20),
  },
  {
    slug: "kaya-cottages",
    itype: "house",
    imageCount: 36,
    title: "Kaya Cottages",
    secondTitle: "£ 525,000",
    description: "KAYAKÖY, FETHİYE",
    detailTitle: "Rustic Paradise",
    detailDescription:
      "Exceptional Dual Stone Cottages with Expansive Gardens, Pools & Mountain Views",
    mainImage: "/assets/images/house/kaya-cottages/34.jpg",
    beds: 6,
    baths: 6,
    area: "533 m2",
    content: [
      {
        type: "paragraph",
        text: "Nestled in a peaceful and picturesque setting, this rare property presents two fully renovated stone cottages set within a generous and uniquely landscaped estate. The property sits on a 533 m² private plot and benefits from an additional 300 m² of usable land incorporated from the adjacent forestry area, resulting in an impressive approx. 800 m² total garden area. This seamless integration of natural surroundings creates a private oasis rich in greenery, tranquility, and charm.",
      },
      {
        type: "paragraph",
        text: "The cottages were thoughtfully renovated in 2019, preserving their traditional stone character while introducing modern comforts and high-quality finishes. The result is a harmonious blend of authenticity and contemporary living, ideal for year-round residence, holiday use, or rental investment.",
      },
      {
        type: "image",
        src: "/assets/images/house/kaya-cottages/36.jpg",
        alt: "Kaya Cottages",
      },
      {
        type: "blockquote",
        text: "Main Cottage",
      },
      {
        type: "paragraph",
        text: "The main house is spacious and well-appointed, offering:",
      },
      {
        type: "list",
        items: [
          "Four comfortable bedrooms",
          "A welcoming living room with fireplace, perfect for cooler evenings",
          "A bright open-plan kitchen, designed for both everyday living and entertaining",
          "Three modern bathrooms",
          "Air conditioning throughout, ensuring comfort in all seasons",
        ],
      },
      {
        type: "paragraph",
        text: "Charming windows and terraces allow natural light to flood the interior while framing beautiful views of the surrounding mountains and Kaya Village.",
      },
      {
        type: "blockquote",
        text: "Second Cottage",
      },
      {
        type: "paragraph",
        text: "The second stone cottage provides an ideal independent living space, perfect for guests, extended family, or rental purposes. It features:",
      },
      {
        type: "list",
        items: [
          "Two bedrooms",
          "An open-plan living room and kitchen",
          "Two bathrooms, one of which includes a luxurious jacuzzi",
          "Fireplace and air conditioning",
          "A cozy yet functional layout offering privacy and comfort",
        ],
      },
      {
        type: "image",
        src: "/assets/images/house/kaya-cottages/9.jpg",
        alt: "Kaya Cottages",
      },
      {
        type: "blockquote",
        text: "Outdoor Living & Grounds",
      },
      {
        type: "paragraph",
        text: "The outdoor areas are a standout feature of this property:",
      },
      {
        type: "list",
        items: [
          "Two small swimming pools set within the garden, ideal for relaxation and cooling off during warm days",
          "Approximately 800 m² of garden space, combining landscaped areas with natural greenery",
          "The adjacent forestry land enhances privacy and provides a serene, nature-rich atmosphere",
          "Multiple areas for outdoor seating, dining, and entertaining",
          "A private garage, offering secure parking and additional storage",
        ],
      },
      {
        type: "image",
        src: "/assets/images/house/kaya-cottages/13.jpg",
        alt: "Kaya Cottages",
      },
      {
        type: "blockquote",
        text: "Views & Location",
      },
      {
        type: "paragraph",
        text: "The property enjoys open views of the surrounding mountains and Kaya Village, creating a sense of connection to the landscape while maintaining privacy and calm. The setting is peaceful and rural, yet suitable for comfortable everyday living or a refined countryside retreat.",
      },
      {
        type: "paragraph",
        text: "This distinctive dual-cottage property offers exceptional flexibility, character, and outdoor living potential. Whether envisioned as a private family compound, a holiday escape, or a high-demand rental investment, it represents a rare opportunity to own a beautifully restored stone estate in a truly scenic environment.",
      },
    ],
    PortfolioList2: getPortfolioImages("kaya-cottages"),
  },
  {
    slug: "villa-kumru",
    itype: "house",
    imageCount: 21,
    title: "Villa Kumru",
    secondTitle: "£ 380,000",
    description: "HISARONU, FETHİYE",
    detailTitle: "Modern Villa with Large Garden",
    detailDescription:
      "Luxury Modern Villa with Private Pool and Mountain Views in Hisarönü Fethiye",
    mainImage: "/assets/images/house/villa-kumru/20.jpg",
    beds: 4,
    baths: 4,
    area: "500 m2",
    content: [
      {
        type: "paragraph",
        text: "Experience the perfect blend of elegance, comfort, and Mediterranean charm in this stunning contemporary villa, nestled in one of Fethiye’s most desirable neighborhoods.",
      },

      {
        type: "image",
        src: "/assets/images/house/villa-kumru/1.jpg",
        alt: "Serenity Villa Exterior",
      },
      {
        type: "paragraph",
        text: "This beautifully designed 3-story home features 4 spacious bedrooms and 4 modern bathrooms, offering refined luxury and privacy throughout. Floor-to-ceiling windows flood the interior with natural light, while sleek architectural lines and high-end finishes create a sophisticated ambiance.",
      },
      {
        type: "blockquote",
        text: "Step outside to your private swimming pool, surrounded by lush gardens and a spacious sun terrace — ideal for relaxing or entertaining. The shaded outdoor lounge and dining area provide the perfect setting for long summer evenings with family and friends.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-kumru/21.jpg",
        alt: "Villa Interior",
      },
      {
        type: "paragraph",
        text: "From the upper balconies, enjoy panoramic views of the mountains and tranquil surroundings. The property is located just minutes away from Fethiye’s pristine beaches, marinas, and fine dining, offering the ultimate in luxury living and convenience.",
      },
      {
        type: "list",
        items: [
          "Property Highlights",
          "4 Bedrooms | 4 Bathrooms",
          "Private Swimming Pool & Landscaped Garden",
          "Spacious Outdoor Lounge & Dining Area",
          "High Ceilings and Floor-to-Ceiling Windows",
          "Modern Open-Plan Living and Kitchen Area",
          "Private Balconies with Mountain Views",
          "Secure, Peaceful Residential Area",
          "Close to Beaches, Shops & Restaurants",
        ],
      },
    ],

    videoPic: "/assets/images/house/villa-kumru/19.jpg",
    videoId: "lKNnHQzEpcc",
    videoText:
      "This property is more than a home — it’s a lifestyle shaped by nature.",
    PortfolioList2: getPortfolioImages("villa-kumru"),
  },
  {
    slug: "calis-deluxvillas",
    itype: "house",
    imageCount: 23,
    title: "Calis Delux Villas",
    secondTitle: "£ 930,000",
    description: "FOÇA, FETHİYE",
    detailTitle: "Luxury Smart-Comfort Villas",
    detailDescription:
      "Four Luxury Villas within walking distance to Çalış Beach",
    mainImage: "/assets/images/house/calis-deluxvillas/17.jpg",
    beds: 4,
    baths: 6,
    area: "400 m2",
    content: [
      {
        type: "paragraph",
        text: "Offering an exceptional blend of modern architecture, wellness features, and year-round comfort, this boutique project in Çalış, Fethiye consists of four detached villas built in the same contemporary style—each designed for premium coastal living and strong rental appeal.",
      },
      {
        type: "paragraph",
        text: "Set on 400 m² of private land with 180 m² of enclosed living space, each villa delivers generous interior volume alongside a beautifully planned outdoor lifestyle: a private pool, sun terrace, and landscaped garden areas ideal for relaxed Mediterranean days.",
      },
      {
        type: "paragraph",
        text: "Inside, the layout is built around an open-plan kitchen concept, connecting seamlessly to the dining and living areas—perfect for hosting, family life, and effortless everyday flow. Large windows and sliding doors open directly onto the pool terrace, bringing in abundant natural light and creating a true indoor–outdoor living experience.",
      },
      {
        type: "image",
        src: "/assets/images/house/calis-deluxvillas/19.jpg",
        alt: "Calis Delux Villas",
      },
      {
        type: "paragraph",
        text: "What makes these homes stand out is the level of comfort and lifestyle specification rarely found this close to the sea. Each villa is designed as a spa-style residence, featuring a hamam (Turkish bath), sauna, jacuzzi, and a dedicated cinema room—bringing private wellness and entertainment into your own home.",
      },
      {
        type: "paragraph",
        text: "For easy, future-proof living, the villas also include underfloor heating and a lift, offering effortless access to upper floors—ideal for multi-generational families, long-term living, or buyers prioritizing comfort and accessibility.",
      },
      {
        type: "paragraph",
        text: "Located in Çalış, Fethiye, and within walking distance to the beach, the villas provide quick access to the promenade, cafés, restaurants, and daily amenities—while still offering privacy and a calm residential setting.",
      },
      {
        type: "image",
        src: "/assets/images/house/calis-deluxvillas/8.jpg",
        alt: "Calis Delux Villas",
      },
      {
        type: "blockquote",
        text: "Property Highlights",
      },
      {
        type: "list",
        items: [
          "Four villas available (same style and specification)",
          "Çalış, Fethiye – walking distance to the beach",
          "400 m² private plot",
          "180 m² enclosed living area",
          "4 bedrooms",
          "6 bathrooms",
          "Open-plan kitchen and living concept",
          "Private pool + sun terrace + garden",
          "Hamam (Turkish bath) + sauna",
          "Jacuzzi",
          "Cinema room",
          "Underfloor heating (ideal for year-round living)",
          "Lift for easy access to upper floors",
        ],
      },
      {
        type: "blockquote",
        text: "Why This Property Works",
      },
      {
        type: "paragraph",
        text: "These villas are a rare match for buyers who want both premium personal use and high-end rental potential—especially in Çalış, where walk-to-beach homes with wellness features are consistently in demand. With spa facilities, a lift, and underfloor heating, these are not just “summer villas”—they’re designed for four-season living.",
      },
    ],
    PortfolioList2: getPortfolioImages("calis-deluxvillas"),
  },
  {
    slug: "calis-villas",
    itype: "house",
    imageCount: 23,
    title: "Calis Villas",
    secondTitle: "£ 415,000",
    description: "FOÇA, FETHİYE",
    detailTitle: "Calis Modern Villas",
    detailDescription:
      "Contemporary 4-Bedroom Villas with Private Pools Near Çalış Beach, Fethiye",
    mainImage: "/assets/images/house/calis-villas/21.jpg",
    beds: 4,
    baths: 5,
    area: "400 m2",
    content: [
      {
        type: "paragraph",
        text: "These newly built contemporary villas are located in a peaceful and well-established residential area of Çalış, Fethiye, offering a refined lifestyle just minutes from the coast. The project consists of three detached villas, all built in the same modern architectural style and offered for sale individually.",
      },
      {
        type: "paragraph",
        text: "Each villa is set on a private 400 m² plot and provides approximately 200 m² of closed living space, carefully designed to balance functionality, comfort, and aesthetics. The villas feature four generously sized bedrooms and five modern bathrooms, making them ideal for family living, holiday use, or high-end rental purposes.",
      },
      {
        type: "paragraph",
        text: "The ground floor opens into a bright and spacious living area with large sliding glass doors that lead directly to the terrace, garden, and pool. This layout creates a strong connection between indoor and outdoor spaces, allowing natural light to fill the interior throughout the day. The modern open-plan design is ideal for entertaining, dining, and everyday living.",
      },
      {
        type: "image",
        src: "/assets/images/house/calis-villas/7.jpg",
        alt: "Calis Villas",
      },
      {
        type: "paragraph",
        text: "Outdoors, each villa offers a private swimming pool, sunbathing terrace, and landscaped garden, providing a tranquil setting for relaxation and social gatherings. The outdoor areas are well-proportioned and easy to maintain, making them suitable for both permanent residents and seasonal use.",
      },
      {
        type: "paragraph",
        text: "The villas are newly constructed using quality materials and contemporary finishes. Clean lines, neutral tones, and modern detailing give the property a timeless and elegant character. All bathrooms are fitted with modern fixtures, and each bedroom is designed to offer privacy and comfort, with several rooms benefiting from balconies overlooking the garden and pool area.",
      },
      {
        type: "paragraph",
        text: "The location is one of the key advantages of this property. Situated only 1.5 km from Çalış Beach, the villas offer quick access to the famous promenade, beach clubs, cafés, restaurants, and daily amenities. Public transport links and main roads are nearby, while Fethiye town center, marina, and harbor are easily reachable by a short drive. Despite this convenience, the area remains calm and residential, making it ideal for year-round living.",
      },
      {
        type: "paragraph",
        text: "These villas are well-suited for a range of buyers, including those seeking a permanent family home, a holiday residence, or a strong investment property in one of Fethiye’s most popular coastal districts. The combination of modern design, private outdoor space, proximity to the beach, and limited availability makes this project a highly attractive opportunity.",
      },

      {
        type: "image",
        src: "/assets/images/house/calis-villas/18.jpg",
        alt: "Calis Villas",
      },
      {
        type: "blockquote",
        text: "Property Highlights",
      },
      {
        type: "list",
        items: [
          "Detached modern villas",
          "Three identical villas available",
          "400 m² private plot",
          "200 m² closed living area",
          "4 bedrooms, 5 bathrooms",
          "Private swimming pool and garden",
          "Newly built with modern finishes",
          "1.5 km to Çalış Beach",
          "Suitable for residential, holiday, or rental use",
        ],
      },
      {
        type: "paragraph",
        text: "These villas offer a rare chance to own a modern, well-located property close to the sea in Fethiye, combining comfort, privacy, and long-term value.",
      },
    ],
    PortfolioList2: getPortfolioImages("calis-villas"),
  },
  {
    slug: "villa-kuluhan",
    itype: "house",
    imageCount: 36,
    title: "Villa Kuluhan",
    secondTitle: "£ 720,000",
    description: "KALKAN, ANTALYA",
    detailTitle: "Exquisite Sea View Villa for Sale",
    detailDescription:
      "A statement of Mediterranean luxury, where panoramic views meet timeless design.",
    mainImage: "/assets/images/house/villa-kuluhan/21.jpg",
    beds: 3,
    baths: 4,
    area: "321 m2",
    content: [
      {
        type: "paragraph",
        text: "Nestled high on the scenic hillsides of Kalkan, this exceptional villa embodies the perfect blend of elegant architecture, natural beauty, and modern comfort. Every element of this property has been carefully designed to maximize the mesmerizing views of Kalkan Bay and the surrounding mountains — a true haven for those seeking sophistication and serenity on the Turkish Riviera.",
      },
      {
        type: "paragraph",
        text: "This magnificent three-storey villa is set on an elevated plot, offering generous living spaces, sun-soaked terraces, and an unparalleled sense of privacy. The villa’s modern design combines whitewashed facades with rich wood accents and terracotta roof details, creating a seamless fusion of contemporary elegance and Mediterranean charm. Upon entering, you are greeted by a spacious open-plan living area that flows effortlessly into the outdoor terrace. Floor-to-ceiling windows flood the interior with natural light, framing uninterrupted sea views from nearly every room. The fully fitted modern kitchen is equipped with high-end appliances and an elegant dining area — ideal for both intimate family dinners and entertaining guests. The villa comprises multiple ensuite bedrooms, each with its own private balcony or terrace overlooking the azure waters of Kalkan. The master suite occupies a prime position on the upper floor, featuring a private terrace perfect for watching the sun set over the bay.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-kuluhan/1.jpg",
        alt: "Villa Kuluhan Exterior",
      },
      {
        type: "paragraph",
        text: "Designed for relaxation and entertaining, the outdoor areas of this villa truly capture the essence of Mediterranean living. The expansive terrace features a private infinity-edge swimming pool, surrounded by comfortable sun loungers and shaded pergolas. The outdoor dining area offers the perfect setting for al fresco meals, enhanced by the tranquil backdrop of the sea and surrounding greenery.",
      },
      {
        type: "blockquote",
        text: "A spacious rooftop terrace crowns the property, providing breathtaking 360° panoramic views — from the sparkling coastline to the rugged Taurus Mountains. It’s an ideal space for sunset cocktails, yoga mornings, or simply unwinding in absolute peace.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-kuluhan/6.jpg",
        alt: "Villa Kuluhan Exterior",
      },
      {
        type: "paragraph",
        text: "Additional Highlights",
      },
      {
        type: "list",
        items: [
          "Air conditioning throughout the property",
          "Solar water heating and energy-efficient systems",
          "Private garage and secure gated entrance",
          "Landscaped gardens with mature Mediterranean plants",
          "High-quality materials and finishes throughout",
          "Excellent rental potential with proven high-season demand",
        ],
      },
      {
        type: "paragraph",
        text: "Location – Kalkan, Antalya",
      },
      {
        type: "paragraph",
        text: "Kalkan is one of Turkey’s most picturesque coastal towns, renowned for its cobblestone streets, whitewashed houses, and fine dining scene. The villa is perfectly situated in a peaceful elevated area, offering privacy while remaining just a few minutes’ drive from Kalkan’s marina, beach clubs, boutiques, and restaurants. Whether you’re seeking a luxurious holiday home, a permanent residence, or a lucrative investment property, this villa offers the ideal combination of beauty, comfort, and location.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-kuluhan/16.jpg",
        alt: "Villa Kuluhan Exterior",
      },
      {
        type: "paragraph",
        text: "Key Details",
      },
      {
        type: "list",
        items: [
          "Location: Kalkan, Antalya",
          "Plot Size: 321 m²",
          "Property Type: Detached Villa",
          "Bedrooms: Multiple ensuite bedrooms",
          "Views: Unobstructed sea and mountain views",
          "Condition: Excellent / Ready to move in",
        ],
      },
    ],
    PortfolioList2: getPortfolioImages("villa-kuluhan"),
  },
  {
    slug: "villa-kalamar",
    itype: "house",
    imageCount: 32,
    title: "Villa Kalamar",
    secondTitle: "£ 830,000",
    description: "KALKAN, ANTALYA",
    detailTitle:
      "Modern Mediterranean Villa with Pool and Breathtaking Bay Views",
    detailDescription: "Modern Villa in Kalkan ideal for invesment",
    beds: 3,
    baths: 3,
    area: "300 m2",
    content: [
      {
        type: "paragraph",
        text: "Perched gracefully on the scenic hillside of Kalkan, this stunning modern villa captures the essence of Mediterranean living, blending elegant architecture with panoramic views of the turquoise bay, the lush mountains, and the charming whitewashed rooftops below. Designed for discerning buyers seeking a blend of sophistication, comfort, and privacy, this exceptional property represents one of Kalkan’s most desirable contemporary homes.",
      },
      {
        type: "paragraph",
        text: "The villa is spread across three meticulously designed levels, featuring expansive glass façades that flood the interiors with natural light and open up to uninterrupted sea and mountain vistas. Every detail has been crafted with a commitment to high-quality materials, modern lines, and refined finishes that create a sense of effortless luxury. The property’s layout balances open-plan social areas with private retreats, making it equally suited for family living, entertaining, or a serene seasonal escape.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-kalamar/31.jpg",
        alt: "Villa Kalamar Exterior",
      },
      {
        type: "blockquote",
        text: "Exterior and Outdoor Living",
      },
      {
        type: "paragraph",
        text: "From the moment you arrive, the villa impresses with its elegant geometric design, landscaped privacy hedges, and a striking infinity pool that seamlessly blends with the horizon. The spacious pool terrace, complete with sun loungers and a shaded dining area, invites relaxation under the Mediterranean sun. Large balconies and glass-fronted terraces wrap around the villa, providing multiple vantage points to enjoy the dazzling scenery—from tranquil morning light over the Taurus Mountains to glowing sunsets across the bay.",
      },
      {
        type: "paragraph",
        text: "The outdoor areas have been designed for low maintenance yet lush living, with mature evergreens ensuring privacy while framing the villa’s crisp white architecture beautifully. The property also includes a private garage and secure gated access, ensuring peace of mind for both residents and guests.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-kalamar/24.jpg",
        alt: "Villa Kalamar Exterior",
      },
      {
        type: "blockquote",
        text: "Interior Design and Living Spaces",
      },
      {
        type: "paragraph",
        text: "Inside, the villa embodies contemporary coastal elegance. The open-plan living room features large sliding doors that connect seamlessly with the outdoor terrace, creating a continuous flow between interior and exterior spaces. The modern kitchen, fitted with premium appliances and ample storage, caters perfectly for home cooking or private chef service. Neutral tones, clean lines, and natural textures combine to create a calm, airy ambiance that reflects the beauty of its surroundings.",
      },
      {
        type: "paragraph",
        text: "With five spacious bedrooms and five bathrooms, each room enjoys privacy and panoramic views. The master suite opens onto a private balcony overlooking the sea, while the guest rooms offer equally stunning perspectives of the surrounding landscape. Every bathroom is styled with modern fixtures, walk-in showers, and elegant tiling, reflecting understated sophistication throughout.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-kalamar/22.jpg",
        alt: "Villa Kalamar Exterior",
      },
      {
        type: "blockquote",
        text: "Location and Lifestyle",
      },
      {
        type: "paragraph",
        text: "Located in one of Kalkan’s most prestigious residential areas, this villa is just minutes from the town center, the marina, and Kalkan’s renowned beach clubs and fine-dining restaurants. The neighborhood offers the ideal combination of tranquility and accessibility—close enough to enjoy Kalkan’s cosmopolitan atmosphere, yet peaceful enough to preserve the serenity of private coastal living.",
      },
      {
        type: "paragraph",
        text: "Kalkan itself is celebrated for its timeless charm, crystal-clear waters, and boutique lifestyle. With its cobbled streets, authentic architecture, and elegant dining scene, it remains one of Türkiye’s most exclusive seaside destinations, attracting an international clientele seeking refined yet relaxed living. This villa offers the opportunity to own a piece of that lifestyle, whether as a permanent residence, a holiday retreat, or a high-return investment in one of the Mediterranean’s most stable real estate markets.",
      },
      {
        type: "blockquote",
        text: "Key Features",
      },
      {
        type: "list",
        items: [
          "Three-storey contemporary villa with panoramic sea and mountain views",
          "Five bedrooms, five bathrooms, and multiple terraces",
          "Infinity pool with sunbathing and lounge area",
          "Open-plan living spaces with floor-to-ceiling windows",
          "Fully equipped modern kitchen",
          "Private garage and landscaped garden",
          "Solar-powered water heating and energy-efficient design",
          "Walking distance to the beach, marina, and Kalkan’s vibrant town center",
        ],
      },
      {
        type: "paragraph",
        text: "This villa is more than a property—it’s an invitation to experience Mediterranean life at its most elegant and effortless. Every sunset over Kalkan Bay, every breeze that sweeps through its terraces, and every morning that begins with the sound of the sea reaffirms why this coastal haven remains one of Türkiye’s finest addresses.",
      },
    ],
    PortfolioList2: getPortfolioImages("villa-kalamar"),
  },
  {
    slug: "villa-bahce",
    itype: "house",
    imageCount: 20,
    title: "Villa Bahçe",
    secondTitle: "£ 315,000",
    description: "İNLİCE, FETHİYE",
    detailTitle: "Development Opportunity in İnlice, Fethiye",
    detailDescription:
      "Prime 730 m² plot near Göcek with an existing 5-bedroom detached house and strong development potential.",
    mainImage: "/assets/images/house/villa-bahce/3.jpg",
    beds: 5,
    baths: 3,
    area: "730 m2",
    content: [
      {
        type: "paragraph",
        text: "Set in the peaceful and increasingly sought-after village of İnlice, this unique property offers an exceptional opportunity for both homeowners and investors. Located just minutes from the world-renowned yachting town of Göcek and within easy reach of Fethiye, the property combines the tranquility of village life with excellent access to the region's most desirable amenities, marinas, beaches, and international transport links.",
      },
      {
        type: "paragraph",
        text: "Occupying a generous 730 m² plot, the property currently features a 195 m² detached house comprising 5 bedrooms and 3 bathrooms, surrounded by mature gardens and established greenery that provide privacy and a charming natural setting.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-bahce/1.jpg",
        alt: "Villa Bahçe",
      },
      {
        type: "blockquote",
        text: "Existing Property Features",
      },
      {
        type: "list",
        items: [
          "195 m² detached residence",
          "5 spacious bedrooms",
          "3 bathrooms",
          "Mature private garden",
          "Secure gated entrance",
          "Established residential neighborhood",
          "Peaceful village setting",
        ],
      },
      {
        type: "blockquote",
        text: "Development Potential",
      },
      {
        type: "paragraph",
        text: "What truly sets this property apart is its outstanding development potential. With a 40% legal building allowance, the plot offers buyers the flexibility to either renovate and modernize the existing residence or take advantage of the generous zoning rights to create two substantial detached villas, making it an attractive option for developers, investors, or those seeking a multi-family living arrangement.",
      },
      {
        type: "list",
        items: [
          "730 m² plot size",
          "40% legal build allowance",
          "Potential to construct two large villas, subject to relevant approvals",
          "Excellent investment opportunity in a rapidly appreciating area",
          "Ideal for luxury villa development or holiday rental investment",
        ],
      },
      {
        type: "image",
        src: "/assets/images/house/villa-bahce/8.jpg",
        alt: "Villa Bahçe Garden",
      },
      {
        type: "blockquote",
        text: "Location Highlights",
      },
      {
        type: "list",
        items: [
          "Located in the charming village of İnlice",
          "Approximately 5 minutes from Göcek",
          "Easy access to Fethiye town centre",
          "Close to marinas, beaches, restaurants, and local amenities",
          "Convenient access to Dalaman International Airport",
          "Surrounded by nature, forests, and countryside views",
        ],
      },
      {
        type: "paragraph",
        text: "Properties offering both an existing family home and significant development potential in this location are becoming increasingly difficult to find. Whether you are looking to create a dream residence, develop luxury villas for resale, or secure a valuable land investment near Göcek, this versatile property represents an exciting opportunity in one of the most desirable areas of the Fethiye region.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-bahce/10.jpg",
        alt: "Villa Bahçe Location",
      },
      {
        type: "blockquote",
        text: "Viewing Recommended",
      },
      {
        type: "paragraph",
        text: "Viewing is highly recommended to fully appreciate the location, flexibility, and future potential this property has to offer.",
      },
    ],
    PortfolioList2: getPortfolioImages("villa-bahce"),
  },
  {
    slug: "villa-efe",
    itype: "house",
    imageCount: 22,
    title: "Villa Efe",
    secondTitle: "£ 270,000",
    description: "ÇALIŞ, FETHİYE",
    detailTitle: "Pool House in Managed Complex",
    detailDescription:
      "3 bedroom house suitable for summer residence or families looking for a quite home.",
    mainImage: "/assets/images/house/villa-efe/22.jpg",
    beds: 3,
    baths: 2,
    area: "190 m2",
    content: [
      {
        type: "paragraph",
        text: "Bathed in golden Çalış sunsets and framed by mountain silhouettes, this spacious 3-bedroom home sits inside a well-kept site (managed residential complex) with a large shared pool and landscaped lawns. It offers the best of Fethiye living: calm, convenience, and quick access to the beach, promenade cafés, and daily amenities.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-efe/19.jpg",
        alt: "Villa Efe",
      },
      {
        type: "blockquote",
        text: "At a glance",
      },
      {
        type: "list",
        items: [
          "Internal area: approx. 190 m²",
          "Bedrooms: 3 generous doubles",
          "Bathrooms/WCs: multiple (family bathroom + guest WC)",
          "Outdoor: covered terrace/veranda spilling onto the gardens",
          "Complex: large communal pool, sun terraces, green areas, paved walkways, evening lighting",
          "Parking: on-site within the development",
          "Comfort: air-conditioning infrastructure; year-round livability",
          "Status: ideal as a full-time residence, lock-up-and-leave holiday home, or long-stay rental (subject to site rules)",
        ],
      },
      {
        type: "blockquote",
        text: "Why this home works",
      },
      {
        type: "paragraph",
        text: "The house prioritizes space and natural light. The open-plan living–dining area connects directly to the terrace, creating an easy indoor–outdoor flow for breakfasts by the garden and relaxed evenings after a swim. Upstairs, three large bedrooms offer privacy for families, friends, or remote work. The proportions—rare for the area—make everyday living comfortable rather than cramped.",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-efe/15.jpg",
        alt: "Villa Efe",
      },
      {
        type: "blockquote",
        text: "Layout & flow (indicative)",
      },
      {
        type: "paragraph",
        text: "Ground Floor: welcoming entry hall with storage; open-plan lounge & dining zone oriented toward the garden; a practical kitchen with room for full-size appliances; guest WC; wide glass doors to a shaded veranda overlooking lawns and the pool axis. Upper Floor(s): three spacious bedrooms, each with good natural light; a family bathroom; potential to designate one bedroom as a home office, nursery, or hobby room. Outdoor Living: the terrace easily accommodates an 6–8 person table or lounge set; the surrounding communal lawns feel like an extension of your private space without the maintenance burden.",
      },
      {
        type: "blockquote",
        text: "The complex",
      },
      {
        type: "paragraph",
        text: "Life here centres on a hotel-sized shared pool with dedicated sunbeds and generous surrounds, ideal for morning laps or late-afternoon cool-offs. Mature planting softens the architecture and delivers a resort mood year-round. Paved internal paths and warm garden lighting make twilight strolls safe and atmospheric. A professional caretaker/management structure typically oversees gardening, pool care, and communal electricity—meaning your weekends are for enjoyment, not chores.",
      },
      {
        type: "blockquote",
        text: "Finishes & comfort notes",
      },
      {
        type: "paragraph",
        text: "Cooling/heating: infrastructure for split-AC units; the build suits year-round living. Windows/doors: broad openings for airflow and light; terrace access from the main living area. Storage: entry and hall closets plus scope to add cabinetry in circulation spaces. Utilities: mains water/electric; internet availability in the neighborhood. (Specifications reflect the home and site context; full inclusions can be supplied at viewing.)",
      },
      {
        type: "image",
        src: "/assets/images/house/villa-efe/3.jpg",
        alt: "Villa Efe",
      },
      {
        type: "blockquote",
        text: "Lifestyle & investment",
      },
      {
        type: "paragraph",
        text: "Çalış is beloved for its promenade, cycling paths, and beach sunsets—all within easy reach of the home. Daily life is effortless: supermarkets, bakeries, weekly markets, pharmacies, and cafés sit a short drive or bike ride away. For evenings out, Fethiye’s marina and old town restaurants are nearby; Ölüdeniz and Kayaköy are classic weekend escapes. The area shows strong long-stay and seasonal rental demand, supporting hybrid lifestyle-investment ownership (subject to municipal and site regulations).",
      },
      {
        type: "blockquote",
        text: "Location & distances (approx.)",
      },
      {
        type: "list",
        items: [
          "Çalış Beach/Promenade: minutes away",
          "Fethiye Center & Marina: ~10–15 min by car",
          "Ölüdeniz Lagoon: ~25–30 min",
          "Dalaman International Airport: ~45–50 min",
        ],
      },
      {
        type: "blockquote",
        text: "Who it suits",
      },
      {
        type: "list",
        items: [
          "Families wanting space, a pool, and a friendly, secure setting",
          "Couples or remote workers seeking light, quiet, and easy access to services",
          "Investors/second-home buyers prioritizing low-maintenance ownership in a proven coastal location",
        ],
      },
    ],
    PortfolioList2: getPortfolioImages("villa-efe"),
  },
  {
    slug: "manzara-home",
    itype: "house",
    imageCount: 19,
    title: "Manzara Home",
    secondTitle: "£ 160,000",
    description: "TAŞYAKA, FETHİYE",
    detailTitle: "Panoramic 2 Bedroom Flat",
    detailDescription:
      "105 m2 flat with incredible views over Fethiye Harbour in a newly built neighborhood.",
    mainImage: "/assets/images/house/manzara-home/8.jpg",
    beds: 2,
    baths: 1,
    area: "105 m2",
    content: [
      {
        type: "paragraph",
        text: "Commanding postcard vistas over Fethiye Bay and the evergreen hillside, this 105 m², 2-bedroom apartment pairs calm, contemporary design with a four-season enclosed terrace—ideal for full-time living, a sophisticated holiday base, or a high-appeal rental.",
      },
      {
        type: "image",
        src: "/assets/images/house/manzara-home/14.jpg",
        alt: "Manzara Home",
      },
      {
        type: "blockquote",
        text: "At a Glance",
      },
      {
        type: "list",
        items: [
          "Size: ~105 m² internal area",
          "Rooms: 2 bedrooms | 1 bathroom",
          "Plan: Open-plan kitchen–living–dining flowing to an enclosed, glass-fronted terrace",
          "Orientation: Bay panorama + green hillside outlook",
          "Comfort: Split A/Cs for heating & cooling; double glazing; LED cove lighting; focal fireplace/stove",
          "Finish: Light wood floors, black aluminium frames, neutral décor—move-in ready",
        ],
      },
      {
        type: "blockquote",
        text: "Interior Narrative",
      },
      {
        type: "paragraph",
        text: "Entrance & Storage. A practical hall welcomes you with space for a console, coat rail and shoe cabinet—everyday clutter solved the moment you step inside. Living Core. The corner living room is wrapped on two sides by full-height glazing, turning the view into living art. The round rug defines a cosy seating zone anchored by the contemporary stove—perfect for winter evenings with the city lights twinkling below. Four-Season Terrace. Sliding glass partitions create a true winter garden: a breakfast corner in spring, breezy aperitivo lounge in summer, sun-trap reading nook on crisp winter days. Rattan seating and a bar-style counter (as pictured) make entertaining effortless. Kitchen Open to the living area for social cooking; current layout suits an L- or straight-line kitchen with full-height fridge space, oven/hob, and overhead storage. Bedrooms. Two calm, well-proportioned rooms—configure as principal + guest, child’s room, or a serene home office. Bathroom.",
      },
      {
        type: "image",
        src: "/assets/images/house/manzara-home/15.jpg",
        alt: "Manzara Home",
      },
      {
        type: "blockquote",
        text: "Materials & Systems",
      },
      {
        type: "list",
        items: [
          "Black aluminium glazing with generous sliders",
          "Split air-conditioning (cooling & heating)",
          "Feature stove/fireplace as a visual and seasonal focal point",
          "LED cove/indirect lighting for soft evening ambience",
        ],
      },
      {
        type: "blockquote",
        text: "Building & Practicalities",
      },
      {
        type: "list",
        items: [
          "Boutique, well-kept building in a quiet hillside setting",
          "Upper-floor placement for privacy and uninterrupted outlook",
          "Parking options in the vicinity ",
          "Structural/earthquake compliance reports available on request (to be confirmed)",
        ],
      },
      {
        type: "blockquote",
        text: "Lifestyle & Setting",
      },
      {
        type: "paragraph",
        text: "From morning turquoise to gold-pink sunsets, the bay is your daily backdrop. You’re minutes from the harbour, Old Town restaurants, weekly markets, and the seaside promenade—yet the apartment feels worlds away, facing a tranquil green slope dotted with pines. Lycian Way paths, marinas, and sandy beaches are all short drives.",
      },
      {
        type: "image",
        src: "/assets/images/house/manzara-home/18.jpg",
        alt: "Manzara Home",
      },
      {
        type: "blockquote",
        text: "Approx. Distances",
      },
      {
        type: "list",
        items: [
          "Harbour & Old Town: 10–15 min drive",
          "Çalış Beach: 15–20 min",
          "Ölüdeniz (Blue Lagoon): 25–30 min",
          "Göcek marinas: ~30–35 min",
          "Dalaman Airport: 45–55 min",
        ],
      },
      {
        type: "blockquote",
        text: "Investment & Rental Outlook",
      },
      {
        type: "list",
        items: [
          "Demand drivers: panoramic view, enclosed terrace for year-round use, modern finishes",
          "Use cases: lock-up-and-leave second home; premium mid-term rental for remote workers; short-let holiday rental",
          "Yield note: View properties in this bracket historically outperform standard flats in occupancy and nightly rates",
        ],
      },
      {
        type: "blockquote",
        text: "Who This Home Suits",
      },
      {
        type: "list",
        items: [
          "View lovers seeking daily “wow” without villa-level upkeep",
          "Couples or small families wanting proximity to town with quiet at home",
          "Buyers planning a hybrid personal-use + rental strategy",
        ],
      },
      {
        type: "blockquote",
        text: "Layout",
      },
      {
        type: "paragraph",
        text: "Entry hall → two bedrooms to one side → family bathroom → open-plan kitchen/living/dining → enclosed panoramic terrace (winter garden).",
      },
    ],
    PortfolioList2: getPortfolioImages("manzara-home"),
  },
  {
    slug: "villa-manolya",
    itype: "house",
    imageCount: 15,
    title: "Villa Manolya",
    secondTitle: "£ 295,000",
    description: "AKARCA, FETHİYE",
    detailTitle: "Three-Storey Villa",
    detailDescription:
      "Contemporary 4-Bedroom Triplex with Private Pool in Central",
    mainImage: "/assets/images/house/villa-manolya/8.jpg",
    beds: 4,
    baths: 3,
    area: "150 m2",
    content: [
      {
        type: "blockquote",
        text: "Why this home",
      },
      {
        type: "paragraph",
        text: "Perfectly set in one of Fethiye’s most convenient and family-friendly neighbourhoods, this modern villa delivers year-round comfort and effortless indoor-outdoor living. The address places you moments from the coastal promenade and level walking/cycling routes, yet tucked within a calm residential street. Quality construction, full climate control (underfloor heating + A/C), and a low-maintenance layout make it equally suited to permanent residence, a holiday base, or a high-yield rental.",
      },
      {
        type: "blockquote",
        text: "Layout & Interiors",
      },
      {
        type: "list",
        items: [
          "Bright open-plan lounge and dining with wide sliding doors to the terrace and pool—excellent natural light and easy flow for entertaining.",
          "Modern fitted kitchen with generous cabinetry and worktops.",
          "Guest WC and built-in storage.",
        ],
      },
      {
        type: "image",
        src: "/assets/images/house/villa-manolya/1.jpg",
        alt: "Villa Manolya",
      },
      {
        type: "blockquote",
        text: "First Floor – Quiet bedrooms",
      },
      {
        type: "list",
        items: [
          "Two comfortable double bedrooms, each with balcony access for morning coffee or evening breeze.",
          "A family bathroom serves this level (plus linen/storage niche).",
        ],
      },
      {
        type: "blockquote",
        text: "Top Floor – Flexible private level",
      },
      {
        type: "list",
        items: [
          "Two additional bedrooms set beneath a modern roofline—use as a primary bedroom + office, teen suite, or hobby/studio spaces.",
          "Additional bathroom facilities on this level (verify configuration on viewing).",
        ],
      },
      {
        type: "paragraph",
        text: "Throughout the house you’ll find double-glazed windows, neutral finishes, and hard-wearing flooring—an easy canvas for your own style.",
      },
      {
        type: "blockquote",
        text: "Outdoor Space",
      },
      {
        type: "list",
        items: [
          "Private swimming pool bordered by hedging for privacy.",
          "Sun terrace with ample room for loungers and a dining set; seamless access from the living area for true indoor–outdoor living.",
          "Compact garden zones designed for low upkeep.",
          "Secure perimeter and gated entry.",
        ],
      },
      {
        type: "blockquote",
        text: "Technical & Comfort Features",
      },
      {
        type: "list",
        items: [
          "Underfloor heating for even, efficient warmth in winter.",
          "Inverter A/C units for cooling and supplemental heating.",
          "Insulated envelope and quality glazing for year-round efficiency.",
          "Newly built structure; turnkey condition.",
        ],
      },
      {
        type: "image",
        src: "/assets/images/house/villa-manolya/14.jpg",
        alt: "Villa Manolya",
      },
      {
        type: "blockquote",
        text: "Location & Lifestyle — Akarca Advantage",
      },
      {
        type: "list",
        items: [
          "A short, flat stroll to the Fethiye promenade (coastal path, playgrounds, cafés, sunset views).",
          "Quick access to supermarkets, bakeries, weekly markets, pharmacies, and public transport.",
          "Çalış Beach and Fethiye town centre/marina within easy reach; schools and healthcare close by.",
          "Ideal for car-free living and rental appeal thanks to centrality.",
        ],
      },
      {
        type: "blockquote",
        text: "Investment Potential",
      },
      {
        type: "paragraph",
        text: "Akarca’s central position and improving public realm keep demand strong for modern homes with private outdoor space. This villa’s 4-bed layout, climate control, and pool create a compelling profile for both long-term residence and short-/mid-term rentals. Ask us for yield assumptions and management options.",
      },
      {
        type: "blockquote",
        text: "At-a-Glance Highlights",
      },
      {
        type: "list",
        items: [
          "160 m² three-storey 4-bedroom villa",
          "Private pool, sun terrace, and balconies on upper floors",
          "Underfloor heating + A/Cs for year-round comfort",
          "Newly built; light, contemporary finishes",
          "Central Akarca setting near promenade, parks, and amenities",
        ],
      },
      {
        type: "blockquote",
        text: "Ready to view?",
      },
      {
        type: "paragraph",
        text: "Contact us to receive the full photo set, floor plan, and a personalised viewing appointment.",
      },
    ],
    PortfolioList2: getPortfolioImages("villa-manolya"),
  },
  {
    slug: "pamir-house",
    itype: "house",
    imageCount: 12,
    title: "Pamir House",
    secondTitle: "£ 150,000",
    description: "MURATPAŞA, ANTALYA",
    detailTitle: "Duplex in Antalya",
    detailDescription: "Bright & Elegant 2-Bedroom Duplex in Central",
    mainImage: "/assets/images/house/pamir-house/4.jpg",
    beds: 4,
    baths: 3,
    area: "120 m2",
    content: [
      {
        type: "paragraph",
        text: "Welcome to a calm, light-filled home in one of Antalya’s most sought-after districts. This 120 m², 2-bedroom duplex in Muratpaşa blends generous proportions with a warm, contemporary aesthetic—ideal for an end-user seeking comfort and convenience, or an investor looking for stable, year-round demand.",
      },
      {
        type: "image",
        src: "/assets/images/house/pamir-house/5.jpg",
        alt: "Pamir House",
      },
      {
        type: "blockquote",
        text: "Property Overview",
      },
      {
        type: "list",
        items: [
          "Type: Duplex apartment (2 levels)",
          "Size: 120 m²",
          "Bedrooms: 2",
          "Bathrooms/WC: 2 ",
          "District: Muratpaşa, Antalya",
        ],
      },
      {
        type: "blockquote",
        text: "Interior & Design",
      },
      {
        type: "paragraph",
        text: "Enter into an open-plan living and dining area designed for both everyday ease and entertaining. Neutral wall textures, tray ceilings with recessed spot lighting, and wide, pale flooring create a sense of volume and brightness. The lounge is arranged for relaxed conversation and media, with a practical radiator heating system enhancing comfort in the cooler months.",
      },
      {
        type: "blockquote",
        text: "Kitchen You’ll Use Every Day",
      },
      {
        type: "paragraph",
        text: "The sleek, integrated kitchen anchors the social heart of the home. A curved breakfast island with seating invites informal meals, homework, or a wine with friends while cooking. Well-planned cabinetry, a built-in oven and hob, and ample counter space make the kitchen as functional as it is attractive. The open connection to the living area means the cook never misses the conversation.",
      },
      {
        type: "blockquote",
        text: "Bedrooms & Private Spaces",
      },
      {
        type: "paragraph",
        text: "Upstairs, the duplex layout naturally separates day and night zones. Two comfortable bedrooms provide quiet retreats with good wardrobe potential. The plan supports two bathrooms/WC, streamlining busy mornings and offering privacy for guests. Finishes remain in soothing tones to promote rest and easy personalization.",
      },
      {
        type: "image",
        src: "/assets/images/house/pamir-house/9.jpg",
        alt: "Pamir House",
      },
      {
        type: "blockquote",
        text: "Comfort & Practicality",
      },
      {
        type: "list",
        items: [
          "Open-plan layout for modern living",
          "Radiator heating visible in the lounge",
          "Ceiling details & recessed lighting for a tailored, finished look",
          "Quality flooring in light tones, easy to maintain and style",
          "Move-in ready condition; neutral palette suits many tastes",
        ],
      },
      {
        type: "blockquote",
        text: "Location Benefits — Muratpaşa",
      },
      {
        type: "paragraph",
        text: "Muratpaşa is prized for its centrality and everyday convenience. From this address you’re close to daily amenities, markets, cafés, pharmacies, schools, and service providers, with straightforward access to public transport and main arteries across Antalya. The district’s steady, local demand makes this home a sound long-term investment as well as an enjoyable place to live.",
      },
      {
        type: "blockquote",
        text: "Who This Home Suits",
      },
      {
        type: "list",
        items: [
          "Professionals or small families seeking a calm base in the city",
          "Seasonal residents wanting a lock-up-and-leave with easy maintenance",
          "Investors targeting year-round rental demand in a central location",
        ],
      },
      {
        type: "blockquote",
        text: "At a Glance",
      },
      {
        type: "list",
        items: [
          "120 m² | 2 bedrooms | 2 levels (duplex)",
          "Open-plan lounge–kitchen with island seating",
          "Radiator heating, recessed lighting, soft contemporary finishes",
          "Prime Muratpaşa setting near all daily needs",
        ],
      },
      {
        type: "blockquote",
        text: "Title deed (Tapu) ready.",
      },
      {
        type: "paragraph",
        text: "For the full photo set, floor details, and to arrange your private viewing, contact us today. Homes of this size and quality in central Muratpaşa are in limited supply—don’t miss this one.",
      },
    ],
    PortfolioList2: getPortfolioImages("pamir-house"),
  },
  {
    slug: "akarca1-house",
    itype: "house",
    imageCount: 17,
    title: "AKARCA TOWNHOUSE 1",
    secondTitle: "£ 335,000",
    description: "AKARCA, FETHİYE",
    detailTitle: "AKARCA TOWNHOUSE 1",
    detailDescription:
      "Charming Three-Storey Townhouse with Sea-View Terrace in Akarca, Fethiye",
    mainImage: "/assets/images/house/akarca1-house/13.jpg",
    beds: 3,
    baths: 2,
    area: "160 m2",
    content: [
      {
        type: "paragraph",
        text: "Located in one of Fethiye’s most desirable residential areas, this three-storey, three-bedroom townhouse in Akarca offers an excellent combination of coastal lifestyle, green surroundings and easy access to daily amenities. Just a few minutes’ walk from the seafront promenade, parks and cycle paths, the property is ideally positioned for year-round living, a family holiday home or a high-demand rental investment.",
      },
      {
        type: "paragraph",
        text: "Offering approximately 160 m² open area, the house is arranged over three floors, providing well-proportioned rooms and flexible use of space. The entrance level features a welcoming living area that opens onto the garden, ideal for relaxing in the shade of mature trees. Upper floors accommodate three comfortable bedrooms and additional sitting or hobby areas, allowing privacy for family members or guests. Large windows bring in plenty of natural light and greenery from the surrounding palm and pine trees.",
      },
      {
        type: "image",
        src: "/assets/images/house/akarca1-house/16.jpg",
        alt: "AKARCA TOWNHOUSE 1",
      },
      {
        type: "paragraph",
        text: "The standout feature of this townhouse is the spacious top-floor terrace with views towards the sea and the mountains. This charming outdoor area is perfect for al fresco dining, evening drinks or simply enjoying Fethiye’s sunsets and sea breeze. With a little updating, it can easily become a stylish roof lounge or summer kitchen.",
      },
      {
        type: "paragraph",
        text: "Akarca is known for its quiet, residential character while still being close to supermarkets, schools, cafés, restaurants, the state hospital and public transport links. Properties in this neighbourhood rent quickly and hold their value well, making this townhouse a smart choice for buyers who want both lifestyle and investment potential.",
      },
      {
        type: "image",
        src: "/assets/images/house/akarca1-house/1.jpg",
        alt: "AKARCA TOWNHOUSE 1",
      },
      {
        type: "blockquote",
        text: "Key Features",
      },
      {
        type: "list",
        items: [
          "Three-storey townhouse in popular Akarca, Fethiye",
          "Approx. 135 m² closed living space",
          "160 m² open area",
          "3 bedrooms plus flexible living areas",
          "Spacious top-floor terrace with sea and mountain views",
          "Set among mature trees, in a quiet yet central residential street",
          "Only minutes’ walk to the seafront promenade, parks and cycle paths",
          "Close to shops, cafés, schools, hospitals and public transport",
          "Ideal for year-round living, holiday home or rental investment in a high-demand neighbourhood",
        ],
      },
    ],
    PortfolioList2: getPortfolioImages("akarca1-house"),
  },
  {
    slug: "akarca2-house",
    itype: "house",
    imageCount: 12,
    title: "AKARCA TOWNHOUSE 2",
    secondTitle: "£ 335,000",
    description: "AKARCA, FETHİYE",
    detailTitle: "AKARCA TOWNHOUSE 2",
    detailDescription:
      "Charming Three-Storey Townhouse with Sea-View Terrace in Akarca, Fethiye",
    mainImage: "/assets/images/house/akarca2-house/7.jpg",
    beds: 3,
    baths: 3,
    area: "195 m2",
    content: [
      {
        type: "paragraph",
        text: "Located in one of Fethiye’s most desirable residential areas, this three-storey, three-bedroom townhouse in Akarca offers an excellent combination of coastal lifestyle, green surroundings and easy access to daily amenities. Just a few minutes’ walk from the seafront promenade, parks and cycle paths, the property is ideally positioned for year-round living, a family holiday home or a high-demand rental investment.",
      },
      {
        type: "paragraph",
        text: "Offering approximately 195 m² open area, the house is arranged over three floors, providing well-proportioned rooms and flexible use of space. The entrance level features a welcoming living area that opens onto the garden, ideal for relaxing in the shade of mature trees. Upper floors accommodate three comfortable bedrooms and additional sitting or hobby areas, allowing privacy for family members or guests. Large windows bring in plenty of natural light and greenery from the surrounding palm and pine trees.",
      },
      {
        type: "image",
        src: "/assets/images/house/akarca2-house/3.jpg",
        alt: "AKARCA TOWNHOUSE 2",
      },
      {
        type: "paragraph",
        text: "The standout feature of this townhouse is the spacious top-floor terrace with views towards the sea and the mountains. This charming outdoor area is perfect for al fresco dining, evening drinks or simply enjoying Fethiye’s sunsets and sea breeze. With a little updating, it can easily become a stylish roof lounge or summer kitchen.",
      },
      {
        type: "paragraph",
        text: "Akarca is known for its quiet, residential character while still being close to supermarkets, schools, cafés, restaurants, the state hospital and public transport links. Properties in this neighbourhood rent quickly and hold their value well, making this townhouse a smart choice for buyers who want both lifestyle and investment potential.",
      },
      {
        type: "image",
        src: "/assets/images/house/akarca2-house/11.jpg",
        alt: "AKARCA TOWNHOUSE 2",
      },
      {
        type: "blockquote",
        text: "Key Features",
      },
      {
        type: "list",
        items: [
          "Three-storey townhouse in popular Akarca, Fethiye",
          "Approx. 145 m² closed living space",
          "195 m² open area",
          "3 bedrooms plus flexible living areas",
          "Spacious top-floor terrace with sea and mountain views",
          "Set among mature trees, in a quiet yet central residential street",
          "Only minutes’ walk to the seafront promenade, parks and cycle paths",
          "Close to shops, cafés, schools, hospitals and public transport",
          "Ideal for year-round living, holiday home or rental investment in a high-demand neighbourhood",
        ],
      },
    ],
    PortfolioList2: getPortfolioImages("akarca2-house"),
  },
];

export default HouseDetailPageInfo;
